webpackJsonp([9],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "0+am":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/certification@2x.b42e1c6.png";

/***/ }),

/***/ "02pT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1GAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons__ = __webpack_require__("N4+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VipDialog__ = __webpack_require__("rRu1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__VipDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__video_mixin__ = __webpack_require__("zN7k");












/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__video_mixin__["a" /* default */]],
  components: {
    VipDialog: __WEBPACK_IMPORTED_MODULE_7__VipDialog___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['options', 'liveInfo', 'liveUrl', 'liveType', 'isLive', 'isMobile', 'serverTime', 'posterUrl', 'emcee', 'videoID', 'user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['pageType', 'isVip']), {
    poster: {
      get: function get() {
        return this.posterUrl;
      },
      set: function set(v) {
        this.$store.dispatch('setPosterUrl', v);
      }
    },
    title: function title() {
      return this.$route.meta.subTitle || this.liveInfo.title;
    },
    wechatUrl: function wechatUrl() {
      return this.getEmceeInfo('wechat');
    },
    isVipPageAndNotAVip: function isVipPageAndNotAVip() {
      return false;
    },
    isUseM3u8: function isUseM3u8() {
      return this.isMobile || __WEBPACK_IMPORTED_MODULE_6__commons__["c" /* device */].isIpad;
    }
  }),
  data: function data() {
    return {
      tv: null,
      isLoading: false,
      isShowNextTV: false,
      isCloseNextTV: false,
      nowDatas: {},
      nowData: {},
      monitorID: '',
      timeRange: 30 * 60 * 1000,
      repeatUrl: '',
      repeatImageUrl: '',
      player: null,
      waitingTimer: null,
      curUrl: '',
      showVipDialog: false
    };
  },

  watch: {
    $route: function $route(to, from) {
      if (this.liveUrl) {
        this.$store.dispatch('setLiveUrl', false);
      }
      this.init();
    },
    liveUrl: function liveUrl(v) {
      var _this = this;

      if (v) {
        if (this.isLive) {
          if (this.isVipPageAndNotAVip) {
            return false;
          }
          this.repeatUrl = '';
          this.repeatImageUrl = '';
          this.$nextTick(function () {
            _this.loadVideo(v);
          });
        } else {
          this.repeatUrl = v;
          this.setRepeatImageUrl(this.options[this.liveType].repeatImage);
        }
      } else {
        this.repeatUrl = '';
        this.repeatImageUrl = '';
        this.disposePlayer();
        this.clearWaitingTimer();
      }
    },
    monitorID: function monitorID(v, oldVal) {
      if (v) {}
    },
    serverTime: function serverTime(v) {
      this.showNextTVTips(v);
    },
    user: function user(v) {
      if (this.pageType === 'vip') {
        this.init();
      }
    }
  },
  created: function created() {
    if (this.pageType !== 'vip') {
      this.init();
    }
  },

  methods: {
    getLiveState: function getLiveState(datas) {
      var videoType = this.$route.meta.type;

      if (datas.live && videoType.indexOf(datas.live.type) > -1) {
        return datas.live.url;
      }
      return false;
    },
    setCustomTitle: function setCustomTitle(info) {
      if (info && info.memo_title) {
        this.customTitle = info.memo_title;
      }
    },
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        console.log(_this2.$route.meta.type);
        var routerType = _this2.$route.meta.type;
        _this2.getLiveShow(routerType).then(function (datas) {
          var allDataTypes = ['live', 'prevue', 'repeat'];
          var nowData = null;
          for (var i = 0, l = allDataTypes.length; i < l; i++) {
            nowData = datas[allDataTypes[i]];
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(nowData).length) {
              break;
            }
          }
          var url = nowData.url;
          var type = nowData.type;
          window._videoType = type;
          var isLive = !!datas.live.url;

          var poster = '';
          var offline = datas.offline;
          var repeat = datas.repeat;
          var prevue = datas.prevue;
          var emcee = nowData.emcee;

          var videoID = nowData.id;
          var tradingVideoID = videoID;

          _this2.monitorID = nowData.monitor_id;
          if (isLive) {
            if (_this2.isUseM3u8) {
              url = nowData.url;
            } else {
              url = nowData.url_flv;
            }
            _this2.setCustomTitle(datas.live);
          } else {
            if (_this2.compareTheTime(_this2.serverTime || new Date().getTime(), offline.live_end_time) && !offline.repeat_url) {
              type = offline.type || routerType;
              url = '';
              emcee = offline.emcee;
              poster = _this2.options[type].overImg;
              tradingVideoID = offline.id;
              _this2.setCustomTitle(offline);
            } else {
              if (prevue.id) {
                tradingVideoID = prevue.id;
              } else {
                tradingVideoID = repeat.id;
              }

              if (!_this2.compareTheTime(prevue.date)) {
                type = repeat.type || routerType;
                emcee = repeat.emcee;
                url = repeat.repeat_url;
                videoID = repeat.id;
                _this2.repeatUrl = url;
                _this2.setRepeatImageUrl(_this2.options[type].repeatImage);
                _this2.setCustomTitle(repeat);
              } else {
                emcee = prevue.emcee;
                url = '';
                _this2.setCustomTitle(prevue);
              }
            }
          }
          _this2.$store.dispatch('setLiveState', isLive);
          _this2.$store.dispatch('setLiveType', type);
          _this2.$store.dispatch('setEmcee', emcee);
          _this2.$store.dispatch('setVideoID', videoID);
          _this2.$store.dispatch('setTradingVideoID', tradingVideoID);
          _this2.$store.dispatch('setChatReadyState', true);
          _this2.$store.dispatch('setPrevueTime', datas.prevue.date);

          if (!url) {
            _this2.poster = poster || _this2.liveInfo.previewImg;
            return false;
          }
          _this2.$store.dispatch('setLiveUrl', url);
        });
      });
    },
    compareTheTime: function compareTheTime(endTime, startTime) {
      startTime = startTime || this.serverTime;
      startTime = this.timeTrans(startTime);
      endTime = this.timeTrans(endTime);
      var nowTime = startTime || new Date().getTime();
      var diffTime = endTime - nowTime;

      if (diffTime > 0 && diffTime <= this.timeRange) {
        return true;
      }
      return false;
    },
    timeTrans: function timeTrans(time) {
      if (typeof time === 'number') {
        time = time.toString().length < 13 ? time * 1000 : time;
      } else if (typeof time === 'string') {
        time = time.replace(/-/g, '/');
      }
      return new Date(time).getTime();
    },
    loadVideo: function loadVideo(url) {
      if (this.isUseM3u8) {
        url = url.replace('.flv', '.m3u8');
      } else {
        url = url.replace('.m3u8', '.flv');
      }
      if (url.indexOf('https://') === -1) {
        url = url.replace('http:', 'https:');
      }
      this.curUrl = url;

      this.playVideo();
      this.statistics();
      this.closeNextTV();
    },
    disposePlayer: function disposePlayer() {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    },
    playVideo: function playVideo() {
      var _this3 = this;

      var tv = null;
      if (this.isMobile) {
        tv = document.querySelector('#J_tv_video_type');
        tv.src = this.curUrl;

        tv.addEventListener('play', function () {
          _this3.report();
        });

        return false;
      }
      this.disposePlayer();
      var options = {
        mediaType: 'video',
        forceLive: this.isLive,
        sources: [this.curUrl],
        fluid: true,
        poster: this.posterUrl,
        controls: true,
        autoplay: true,
        playsinline: true,
        controlBar: {
          remainingTimeDisplay: true
        }
      };
      if (!this.isLive) {
        options.playbackRates = [1, 1.5, 1.75, 2];
      }
      if (__WEBPACK_IMPORTED_MODULE_6__commons__["c" /* device */].isIE) {
        options.techOrder = Jin10Player.techOrder.FLASH;
      }
      this.player = Jin10Player('#J_tv_box_type', options, function () {
        _this3.clearWaitingTimer();
      });
      this.playerEvents();
    },
    playerEvents: function playerEvents() {
      var _this4 = this;

      window.player = this.player;
      this.player.on('play', function () {
        console.log('play');
        _this4.clearWaitingTimer();

        _this4.report();
      });
      this.player.on('pause', function () {
        console.log('pause');
      });
      this.player.on('ended', function () {
        console.log('ended');
        _this4.errorReplay();
      });
      this.player.on('waiting', function () {
        console.log('waiting');
        _this4.errorReplay(15000);
      });
      this.player.on('ready', function () {
        console.log('ready');
      });
    },
    clearWaitingTimer: function clearWaitingTimer() {
      this.waitingTimer && clearInterval(this.waitingTimer);
    },
    errorReplay: function errorReplay(t) {
      var _this5 = this;

      if (!this.isLive) {
        return false;
      }
      this.clearWaitingTimer();
      this.waitingTimer = setInterval(function () {
        _this5.$tips({
          message: '网络出现波动，正在尝试重新加载',
          type: 'error'
        });

        var img = new Image();
        img.src = '//fm.jin10.com/assets/imgs/network-test.png';
        img.onload = function () {
          _this5.playVideo();
        };
      }, t || 15000);
    },
    getLiveShow: function getLiveShow(type) {
      var _this6 = this;

      var params = type ? { type: type } : '';
      this.isLoading = true;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this6.isVipPageAndNotAVip) {
          var data = {
            live: {},
            offline: {},
            prevue: {},
            repeat: {}
          };
          _this6.showVipDialog = true;
          _this6.nowDatas = data;
          resolve(data);
          _this6.isLoading = false;
          return false;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])({
          type: 'jsonp',
          url: __WEBPACK_IMPORTED_MODULE_5__commons_config__["b" /* requestUrl */].now,
          params: params,
          callback: function callback() {
            _this6.isLoading = false;
          },
          success: function success(res) {
            _this6.nowDatas = res;
            resolve(res);
          },
          error: function error() {
            _this6.isLoading = false;
            reject();
          }
        });
      });
    },
    onSocketData: function onSocketData(code) {
      console.log(code);
      var ele = document.createElement('script');
      ele.innerHTML = code;
      document.body.appendChild(ele);
    },
    showRepeat: function showRepeat() {
      var _this7 = this;

      if (!this.repeatUrl) {
        this.$tips({ message: '暂时无回放视频' });
        return false;
      }
      this.repeatImageUrl = '';
      this.$nextTick(function () {
        _this7.loadVideo(_this7.repeatUrl);
        _this7.repeatUrl = '';
      });
    },
    showNextTV: function showNextTV() {
      var data = this.nowDatas.prevue;
      var type = data.type;
      var emcee = (type === 'tv' || type === 'fangtan') && !data.emcee ? 'Becca' : data.emcee;
      this.closeNextTV();
      this.poster = this.options[type].previewImg;
      this.$store.dispatch('setLiveUrl', '');
      this.$store.dispatch('setLiveType', type);
      this.$store.dispatch('setLiveState', false);

      this.$store.dispatch('setEmcee', emcee);
    },
    closeNextTV: function closeNextTV() {
      if (!this.isShowNextTV) {
        return false;
      }
      this.isShowNextTV = false;
      this.isCloseNextTV = true;
    },
    showNextTVTips: function showNextTVTips(serverTime) {
      if (this.posterUrl) {
        this.closeNextTV();
      }
      if (this.isCloseNextTV || this.isShowNextTV || this.posterUrl) {
        return false;
      }
      if (this.compareTheTime(this.nowDatas.prevue.date, serverTime)) {
        this.isShowNextTV = true;
      }
    },
    getEmceeInfo: function getEmceeInfo(key, obj) {
      var url = '';
      var emcee = this.emcee;
      var liveInfo = obj || this.liveInfo;
      var data = emcee ? liveInfo[emcee] : liveInfo;
      return data[key];
    },
    statistics: function statistics() {
      var img = new Image();
      img.src = 'https://tv-d.jin10.com/bg.png?t=' + this.videoID;
    },
    setRepeatImageUrl: function setRepeatImageUrl(url) {
      if (this.isVipPageAndNotAVip) {
        this.repeatImageUrl = this.options.vip.notVipImage;
        return false;
      }
      this.repeatImageUrl = url;
    },
    toVipPage: function toVipPage() {
      var url = 'https://www.jin10.com/vip/payment/index.html';
      if (this.jsBridge.isApp) {
        this.jsBridge.dispatch('openAppWebViewWithNav', { url: url });
        return false;
      }
      window.open(url, '_blank');
    }
  }
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2LNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons__ = __webpack_require__("N4+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VipDialog__ = __webpack_require__("rRu1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__VipDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__video_mixin__ = __webpack_require__("zN7k");













/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__video_mixin__["a" /* default */]],
  components: {
    VipDialog: __WEBPACK_IMPORTED_MODULE_7__VipDialog___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['options', 'liveInfo', 'liveUrl', 'liveType', 'isLive', 'isMobile', 'serverTime', 'posterUrl', 'emcee', 'videoID', 'user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['pageType', 'isVip', 'isEliteVip']), {
    poster: {
      get: function get() {
        return this.posterUrl;
      },
      set: function set(v) {
        this.$store.dispatch('setPosterUrl', v);
      }
    },
    title: function title() {
      return this.$route.meta.subTitle || this.liveInfo.title;
    },
    wechatUrl: function wechatUrl() {
      return this.getEmceeInfo('wechat');
    },
    isVipPageAndNotAVip: function isVipPageAndNotAVip() {
      return this.pageType === 'vip' && !this.isVip && !this.options.vipVideoFree || this.pageType === 'vip' && this.options.onlySvip && !this.isEliteVip;
    },
    isOnlySvipAndNotSvip: function isOnlySvipAndNotSvip() {
      return this.pageType === 'vip' && this.options.onlySvip && !this.isEliteVip;
    },
    isUseM3u8: function isUseM3u8() {
      return this.isMobile || __WEBPACK_IMPORTED_MODULE_6__commons__["c" /* device */].isIpad;
    }
  }),
  data: function data() {
    return {
      tv: null,
      isLoading: false,
      isShowNextTV: false,
      isCloseNextTV: false,
      nowDatas: {},
      nowData: {},
      monitorID: '',
      timeRange: 30 * 60 * 1000,
      repeatUrl: '',
      repeatImageUrl: '',
      player: null,
      waitingTimer: null,
      curUrl: '',
      showVipDialog: false,
      videoTitle: '',
      customTitle: '',
      chatReadyState: false
    };
  },

  watch: {
    $route: function $route(to, from) {
      if (this.liveUrl) {
        this.$store.dispatch('setLiveUrl', false);
      }
      this.init();
    },
    customTitle: function customTitle() {
      document.title = this.customTitle || this.title;
    },
    liveUrl: function liveUrl(v) {
      var _this = this;

      if (v) {
        if (this.isLive) {
          if (this.isVipPageAndNotAVip) {
            return false;
          }
          this.repeatUrl = '';
          this.repeatImageUrl = '';
          this.$nextTick(function () {
            _this.loadVideo(v);
          });
        } else {
          this.repeatUrl = v;
          this.setRepeatImageUrl(this.options[this.liveType].repeatImage);
        }
      } else {
        this.repeatUrl = '';
        this.repeatImageUrl = '';
        this.disposePlayer();
        this.clearWaitingTimer();
      }
    },
    monitorID: function monitorID(v, oldVal) {
      if (v) {}
    },
    serverTime: function serverTime(v) {
      this.showNextTVTips(v);
    },
    user: function user(v) {
      if (this.pageType === 'vip') {
        this.init();
      }
      if (this.isVipPageAndNotAVip) {
        this.showVipDialog = true;
      }
      if (this.chatReadyState) {
        this.$store.dispatch('setChatReadyState', true);
      }
    },
    chatReadyState: function chatReadyState() {
      if (this.user.id || this.user.fail !== undefined) {
        this.$store.dispatch('setChatReadyState', true);
      }
    }
  },
  created: function created() {
    this.$store.dispatch('setLiveUrl', false);
    this.init();
  },

  methods: {
    setCustomTitle: function setCustomTitle(info) {
      console.log('setCustomTitle', info);
      if (info && (info.memo_title || info.title)) {
        this.customTitle = info.memo_title || info.title;
      }
    },
    setVideoTitle: function setVideoTitle(datas) {
      var _this2 = this;

      var allDataTypes = ['prevue', 'live'];
      allDataTypes.map(function (el) {
        if (datas[el] && datas[el].title) {
          _this2.videoTitle = datas[el].title;
        }
      });
    },
    init: function init() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.customTitle = '';
        var routerType = _this3.$route.meta.type;
        _this3.getLiveShow(routerType).then(function (datas) {
          var allDataTypes = ['live', 'prevue', 'repeat'];
          var nowData = null;
          for (var i = 0, l = allDataTypes.length; i < l; i++) {
            nowData = datas[allDataTypes[i]];
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(nowData).length) {
              break;
            }
          }
          _this3.setVideoTitle(datas);

          var url = nowData.url;
          var type = nowData.type;
          var isLive = !!datas.live.url;
          var poster = '';
          var offline = datas.offline;
          var repeat = datas.repeat;
          var prevue = datas.prevue;
          var emcee = nowData.emcee;

          var videoID = nowData.id;
          var tradingVideoID = videoID;

          _this3.monitorID = nowData.monitor_id;
          if (isLive) {
            if (_this3.isUseM3u8) {
              url = nowData.url;
            } else {
              url = nowData.url_flv;
            }

            _this3.setCustomTitle(datas.live);
            _this3.poster = _this3.isVipPageAndNotAVip ? _this3.options.vip.notVipImg || _this3.options.vip.notVipImage : _this3.options.vip.previewImg;
          } else {
            if (_this3.compareTheTime(_this3.serverTime || new Date().getTime(), offline.live_end_time) && !offline.repeat_url) {
              type = offline.type || routerType;
              url = '';
              emcee = offline.emcee;
              poster = _this3.options[type].overImg;
              tradingVideoID = offline.id;
              _this3.setCustomTitle(offline);
            } else {
              if (prevue.id) {
                tradingVideoID = prevue.id;
              } else {
                tradingVideoID = repeat.id;
              }

              if (!_this3.compareTheTime(prevue.date)) {
                type = repeat.type || routerType;
                emcee = repeat.emcee;
                url = repeat.repeat_url;
                videoID = repeat.id;
                _this3.repeatUrl = url;
                _this3.setRepeatImageUrl((_this3.options[type] || {}).repeatImage);
                _this3.setCustomTitle(repeat);
              } else {
                emcee = prevue.emcee;
                url = '';
                poster = prevue.thumb;
              }
            }
          }
          _this3.$store.dispatch('setLiveState', isLive);
          _this3.$store.dispatch('setLiveType', type);
          _this3.$store.dispatch('setEmcee', emcee);
          _this3.$store.dispatch('setVideoID', videoID);
          _this3.$store.dispatch('setTradingVideoID', tradingVideoID);
          _this3.chatReadyState = true;

          _this3.$store.dispatch('setPrevueTime', datas.prevue.date);

          _this3.resizeSide();

          if (!url) {
            _this3.poster = poster || _this3.liveInfo.previewImg;
            return false;
          }
          if (_this3.isVip || _this3.options.vipVideoFree) {
            _this3.$store.dispatch('setLiveUrl', url);
          }
        });
      });
    },
    compareTheTime: function compareTheTime(endTime, startTime) {
      startTime = startTime || this.serverTime;
      startTime = this.timeTrans(startTime);
      endTime = this.timeTrans(endTime);
      var nowTime = startTime || new Date().getTime();
      var diffTime = endTime - nowTime;

      if (diffTime > 0 && diffTime <= this.timeRange) {
        return true;
      }
      return false;
    },
    timeTrans: function timeTrans(time) {
      if (typeof time === 'number') {
        time = time.toString().length < 13 ? time * 1000 : time;
      } else if (typeof time === 'string') {
        time = time.replace(/-/g, '/');
      }
      return new Date(time).getTime();
    },
    loadVideo: function loadVideo(url) {
      if (this.isUseM3u8) {
        url = url.replace('.flv', '.m3u8');
      } else {
        url = url.replace('.m3u8', '.flv');
      }
      if (url.indexOf('https://') === -1) {
        url = url.replace('http:', 'https:');
      }
      this.curUrl = url;

      this.playVideo();
      this.statistics();
      this.closeNextTV();
    },
    disposePlayer: function disposePlayer() {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    },
    playVideo: function playVideo() {
      var _this4 = this;

      var tv = null;
      if (this.isMobile) {
        tv = document.querySelector('#J_tv_video_vip');
        tv.src = this.curUrl;

        tv.addEventListener('play', function () {
          _this4.report();
        });

        return false;
      }
      this.disposePlayer();
      var options = {
        mediaType: 'video',
        forceLive: this.isLive,
        sources: [this.curUrl],
        fluid: true,
        poster: this.posterUrl,
        controls: true,
        autoplay: true,
        playsinline: true,
        controlBar: {
          remainingTimeDisplay: true
        }
      };
      if (!this.isLive) {
        options.playbackRates = [1, 1.5, 1.75, 2];
      }
      if (__WEBPACK_IMPORTED_MODULE_6__commons__["c" /* device */].isIE) {
        options.techOrder = Jin10Player.techOrder.FLASH;
      }
      this.player = Jin10Player('#J_tv_box_vip', options, function () {
        _this4.clearWaitingTimer();
      });
      this.playerEvents();
    },
    playerEvents: function playerEvents() {
      var _this5 = this;

      window.player = this.player;
      this.player.on('play', function () {
        console.log('play');
        _this5.clearWaitingTimer();

        _this5.report();
      });
      this.player.on('pause', function () {
        console.log('pause');
      });
      this.player.on('ended', function () {
        console.log('ended');
        _this5.errorReplay();
      });
      this.player.on('waiting', function () {
        console.log('waiting');
        _this5.errorReplay(15000);
      });
      this.player.on('ready', function () {
        console.log('ready');
      });
    },
    clearWaitingTimer: function clearWaitingTimer() {
      this.waitingTimer && clearInterval(this.waitingTimer);
    },
    errorReplay: function errorReplay(t) {
      var _this6 = this;

      if (!this.isLive) {
        return false;
      }
      this.clearWaitingTimer();
      this.waitingTimer = setInterval(function () {
        _this6.$tips({
          message: '网络出现波动，正在尝试重新加载',
          type: 'error'
        });

        var img = new Image();
        img.src = '//fm.jin10.com/assets/imgs/network-test.png';
        img.onload = function () {
          _this6.playVideo();
        };
      }, t || 15000);
    },
    getLiveShow: function getLiveShow(type) {
      var _this7 = this;

      var params = type ? { type: type } : '';
      if (!__WEBPACK_IMPORTED_MODULE_5__commons_config__["a" /* isProduction */]) {
        params = params ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, params, { test: '/testing/' }) : { test: '/testing/' };
      }

      this.isLoading = true;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var handleShowVipDialog = function handleShowVipDialog() {
          if (_this7.isVipPageAndNotAVip) {
            _this7.showVipDialog = true;
          }
        };

        if (!('id' in _this7.user)) {
          _this7.$watch('user', function (user) {
            handleShowVipDialog();
          });
        } else {
          handleShowVipDialog();
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])({
          type: 'GET',
          url: __WEBPACK_IMPORTED_MODULE_5__commons_config__["e" /* requestAttendUrl */].now,
          params: params,
          headers: __WEBPACK_IMPORTED_MODULE_5__commons_config__["e" /* requestAttendUrl */].headers,
          callback: function callback() {
            _this7.isLoading = false;
          },
          success: function success(res) {
            _this7.nowDatas = res;
            resolve(res);
          },
          error: function error() {
            _this7.isLoading = false;
            reject();
          }
        });
      });
    },
    onSocketData: function onSocketData(code) {
      var ele = document.createElement('script');
      ele.innerHTML = code;
      document.body.appendChild(ele);
    },
    showRepeat: function showRepeat() {
      var _this8 = this;

      if (!this.repeatUrl) {
        this.$tips({ message: '暂时无回放视频' });
        return false;
      }
      this.repeatImageUrl = '';
      this.$nextTick(function () {
        _this8.loadVideo(_this8.repeatUrl);
        _this8.repeatUrl = '';
      });
    },
    showNextTV: function showNextTV() {
      var data = this.nowDatas.prevue;
      var type = data.type;
      var emcee = (type === 'tv' || type === 'fangtan') && !data.emcee ? 'Becca' : data.emcee;
      this.closeNextTV();
      this.poster = this.options[type].previewImg;
      this.$store.dispatch('setLiveUrl', '');
      this.$store.dispatch('setLiveType', type);
      this.$store.dispatch('setLiveState', false);

      this.$store.dispatch('setEmcee', emcee);
    },
    closeNextTV: function closeNextTV() {
      if (!this.isShowNextTV) {
        return false;
      }
      this.isShowNextTV = false;
      this.isCloseNextTV = true;
    },
    showNextTVTips: function showNextTVTips(serverTime) {
      if (this.posterUrl) {
        this.closeNextTV();
      }
      if (this.isCloseNextTV || this.isShowNextTV || this.posterUrl) {
        return false;
      }
      if (this.compareTheTime((this.nowDatas.prevue || {}).date, serverTime)) {
        this.isShowNextTV = true;
      }
    },
    getEmceeInfo: function getEmceeInfo(key, obj) {
      var url = '';
      var emcee = this.emcee;
      var liveInfo = obj || this.liveInfo;
      var data = (emcee ? liveInfo[emcee] : liveInfo) || {};
      return data[key];
    },
    statistics: function statistics() {
      var img = new Image();
      img.src = 'https://tv-d.jin10.com/bg.png?t=' + this.videoID;
    },
    setRepeatImageUrl: function setRepeatImageUrl(url) {
      if (this.isVipPageAndNotAVip) {
        this.repeatImageUrl = this.isOnlySvipAndNotSvip ? this.options.vip.onlySvipImage : this.options.vip.notVipImg || this.options.vip.notVipImage;
        return false;
      }
      this.repeatImageUrl = url;
    },
    toVipPage: function toVipPage() {
      var url = this.liveRoleType === LIVE_ROLE_TYPE.svip ? 'https://www.jin10.com/vip_payment/index.html#/?tab=elite' : 'https://www.jin10.com/vip/payment/index.html';
      if (this.jsBridge.isApp) {
        this.jsBridge.dispatch('openAppWebViewWithNav', { url: url });
        return false;
      }
      window.open(url, '_blank');
    },
    resizeSide: function resizeSide() {
      var _this9 = this;

      this.$nextTick(function () {
        setTimeout(function () {
          _this9.$bus.$emit('RESIZE_SIDE');
        }, 400);
      });
    }
  }
});

/***/ }),

/***/ "34ml":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/configs/index.js";

/***/ }),

/***/ "4H5W":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYCAMAAADeQm2wAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAIZeKed2nXfC2oQmCTi4P+Ongk4dyRzn2xsO3r3pjGwxdK8cCAAAAjUlEQVQoz6XQyQ7CMAxF0RgwGUoThtIyw/v/n8SLLp8RUu8imyPZScLvWkkgpdIMC5yKYUIUUkQyBCSQBPgbZexcrBccew/PsO7CcYN8Ava7juM21BtsNkc74wEYKc6rnw7WK6Bvim2+EUO1fVnoU14AtHc+4fNQm0iQtBQVeU3KUMMIpxisaViRhimEL09HGlChwvNuAAAAAElFTkSuQmCC"

/***/ }),

/***/ "4Sm4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/header_info_trading.5a30692.jpg";

/***/ }),

/***/ "4eWj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/header_info_trade_college.e065d41.jpg";

/***/ }),

/***/ "5OR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_slick__ = __webpack_require__("MyZg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__plugins_slick__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_3__plugins_slick___default.a
  },
  computed: {
    isReady: function isReady() {
      return this.dataLoaded;
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    $route: function $route() {
      this.list = [];
      this.dataLoaded = false;
    },
    visible: function visible(v) {
      this.$emit('input', v);
      if (v) {
        this.getDatas();
      }
    }
  },
  mounted: function mounted() {
    this.getDatas();
  },
  data: function data() {
    return {
      list: [],
      isLoading: false,
      dataLoaded: false,
      slickOptions: {
        autoplay: false,
        accessibility: false,
        infinite: true,
        arrows: true,
        prevArrow: '.jin-slider-prev',
        nextArrow: '.jin-slider-next',
        slidesToShow: 3,
        slidesToScroll: 3,
        speed: 300,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      }
    };
  },

  methods: {
    getDatas: function getDatas() {
      var _this = this;

      if (this.isLoading) {
        return false;
      }
      this.isLoading = true;
      var type = this.$route.meta.type;
      var params = type ? { type: type } : {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_fetch__["a" /* fetch */])({
        type: 'GET',
        url: __WEBPACK_IMPORTED_MODULE_1__commons_config__["e" /* requestAttendUrl */].preview,
        headers: __WEBPACK_IMPORTED_MODULE_1__commons_config__["e" /* requestAttendUrl */].headers,
        params: params,
        callback: function callback() {
          _this.isLoading = false;
          _this.dataLoaded = true;
        },
        success: function success(_ref) {
          var data = _ref.data;

          _this.list = data;
          if (_this.list.length) {
            _this.$emit('update-prevue-show', true);
          }
        },
        error: function error() {
          _this.isLoading = false;
        }
      });
    },
    filterDate: function filterDate(date) {
      var nowDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["g" /* dateFormat */])(new Date(), 'yyyy/MM/dd');
      var time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["g" /* dateFormat */])(date, 'hh:mm');
      var oDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["g" /* dateFormat */])(date, 'yyyy/MM/dd');
      var days = ['今天', '明天'];
      nowDate = new Date(nowDate).getTime();
      oDate = new Date(oDate).getTime();
      var diffDate = (oDate - nowDate) / (24 * 3600 * 1000);
      if (diffDate === 0 || diffDate === 1) {
        time = days[diffDate] + ' ' + time;
      } else if (diffDate > 1) {
        time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["g" /* dateFormat */])(date, 'MM月dd日 hh:mm');
      }
      return time;
    },
    leave: function leave() {}
  }
});

/***/ }),

/***/ "6lwT":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip-header"
  })
},staticRenderFns: []}

/***/ }),

/***/ "7EpH":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('jin-dialog', {
    attrs: {
      "custom-class": "vip-dialog",
      "size": "mini"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "vip-dialog__h",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("Aee5"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vip-dialog__b"
  }, [_c('h3', [_vm._v(_vm._s(_vm.dialogTitle) + "~")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.textContent))])]), _vm._v(" "), _c('div', {
    staticClass: "vip-dialog__f"
  }, [_c('button', {
    staticClass: "vip-dialog__button plain",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("我知道了")]), _vm._v(" "), _c('button', {
    staticClass: "vip-dialog__button",
    on: {
      "click": _vm.onVipClick
    }
  }, [_vm._v(_vm._s(_vm.submitBtnText))])]), _vm._v(" "), (_vm.pageType === 'tradingNew' || _vm.liveType === 'tradingNew') ? _c('a', {
    staticClass: "upgrade-vip-tips",
    attrs: {
      "href": "https://www.jin10.com/vip_payment/index.html#/"
    },
    on: {
      "click": _vm.onLinkClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.footerText) + " >>\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "7NxD":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "jin-prevue-show"
    },
    on: {
      "leave": _vm.leave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "jin-prevue",
    class: {
      'jin-empty': !_vm.list.length
    },
    attrs: {
      "data-empty": "暂无预告"
    }
  }, [_c('div', {
    staticClass: "jin-wrap jin-wrap-main"
  }, [_c('div', {
    staticClass: "jin-prevue__wrap"
  }, [_c('div', {
    staticClass: "jin-slider-wrap"
  }, [(_vm.isReady) ? _c('slick', {
    ref: "slick",
    staticClass: "jin-slider",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tv-prevue"
    }, [(item.thumb) ? _c('div', {
      staticClass: "tv-prevue__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumb,
        "alt": item.title
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tv-prevue__text"
    }, [_c('div', {
      staticClass: "tv-prevue__title"
    }, [_c('span', [_vm._v(_vm._s(_vm.filterDate(item.date)))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.room_name))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isReady) ? [_c('span', {
    staticClass: "jin-prevue__slider-button jin-slider-prev"
  }, [_c('icon', {
    attrs: {
      "type": "arrow-l"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "jin-prevue__slider-button jin-slider-next"
  }, [_c('icon', {
    attrs: {
      "type": "arrow-r"
    }
  })], 1)] : _vm._e()], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("FbZm");


/***/ }),

/***/ "8oQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("qFKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");




var _this = this;






var Home = function Home(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("zadT"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);

var pageName = ' - 金十数据';
var mode =  false ? '' : 'history';
var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_4__App___default.a,
    children: [{
      path: '/',
      component: Home,
      meta: {
        title: '金十TV直播' + pageName
      }
    }, {
      path: 'tv',
      component: Home,
      meta: {
        type: 'tv',
        title: '金十TV直播' + pageName
      }
    }, {
      path: '303ccae79fc4661d',
      component: Home,
      meta: {
        roomID: 16,
        type: '303ccae79fc4661d',
        title: '金十交易学院' + pageName,
        subTitle: '学员专属直播间'
      }
    }, {
      path: 'xinwenshe',
      component: Home,
      meta: {
        type: 'xinwenshe',
        title: '金十TV直播' + pageName
      }
    }, {
      path: 'tradingNew',
      component: Home,
      meta: {
        type: 'tradingNew',
        title: '金十同声传译' + pageName
      }
    }, {
      path: 'fangtan',
      component: Home,
      meta: {
        type: 'fangtan',
        title: '金十TV直播' + pageName
      }
    }, {
      path: 'tradeCollege',
      component: Home,
      meta: {
        type: 'tradeCollege',
        title: '金十交易学院' + pageName
      }
    }, {
      path: 'live-nav',
      component: Home,
      meta: {
        type: 'live-nav',
        title: '领航汇' + pageName
      }
    }, {
      path: 'daka',
      component: Home,
      meta: {
        type: 'daka',
        title: '金十大咖线程' + pageName
      }
    }, {
      path: 'week8',
      component: Home,
      meta: {
        type: 'week8',
        title: '交易曦游记' + pageName
      }
    }, {
      path: 'vip',
      component: Home,
      meta: {
        type: 'vip',
        title: 'vip直播'
      }
    }, {
      path: 'qihuo',
      component: Home,
      meta: {
        type: 'qihuo',
        title: '金十脱水期货 - 金十数据'
      }
    }, {
      path: 'vTrader',
      component: Home,
      meta: {
        type: 'vTrader',
        title: '超级VIP - 金十数据'
      }
    }, {
      path: 'gamma',
      component: Home,
      meta: {
        type: 'gamma',
        title: 'GMA伽玛 - 金十数据'
      }
    }, {
      path: 'gammaPri',
      component: Home,
      meta: {
        type: 'gammaPri',
        title: '金十数据'
      }
    }, {
      path: 'vip-priv',
      component: Home,
      meta: {
        type: 'vip-priv',
        title: '金十数据'
      }
    }, {
      path: 'ttps-priv',
      component: Home,
      meta: {
        type: 'ttps-priv',
        title: '金十数据'
      }
    }, {
      path: 'vipYear',
      component: Home,
      meta: {
        type: 'vipYear',
        title: '金十数据'
      }
    }, {
      path: 'vipTools',
      component: Home,
      meta: {
        type: 'vipTools',
        title: 'VIP订单流 - 金十数据'
      }
    }, {
      path: 'live-btnws',
      component: Home,
      meta: {
        type: 'live-btnws',
        title: 'Better News高见 - 金十数据'
      }
    }]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(to.path === '/qh-watch')) {
              _context.next = 30;
              break;
            }

            if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.hasGetDingInfo) {
              _context.next = 15;
              break;
            }

            if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.hasBuyDing) {
              _context.next = 6;
              break;
            }

            next();
            _context.next = 13;
            break;

          case 6:
            if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.hasGetDingShowConfig) {
              _context.next = 10;
              break;
            }

            if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.dingShowConfig.show) {
              next();
            } else {
              next({
                path: '/'
              });
            }
            _context.next = 13;
            break;

          case 10:
            _context.next = 12;
            return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('getDingShowConfig');

          case 12:
            if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.dingShowConfig.show) {
              next();
            } else {
              next({
                path: '/'
              });
            }

          case 13:
            _context.next = 28;
            break;

          case 15:
            _context.next = 17;
            return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('getDingInfo');

          case 17:
            if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.hasBuyDing) {
              _context.next = 21;
              break;
            }

            next();
            _context.next = 28;
            break;

          case 21:
            if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.hasGetDingShowConfig) {
              _context.next = 25;
              break;
            }

            if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.dingShowConfig.show) {
              next();
            } else {
              next({
                path: '/'
              });
            }
            _context.next = 28;
            break;

          case 25:
            _context.next = 27;
            return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('getDingShowConfig');

          case 27:
            if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.dingShowConfig.show) {
              next();
            } else {
              next({
                path: '/'
              });
            }

          case 28:
            _context.next = 31;
            break;

          case 30:
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('getDingInfo'), __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('getDingShowConfig')]).then(function () {
              next();
            });

          case 31:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "8z31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9JkP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['liveInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['hasBuyDing']), {
    notice: function notice() {
      return this.liveInfo.notice || {};
    }
  }),
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {},
  mounted: function mounted() {
    var _this = this;

    var me = this;
    this.$nextTick(function () {
      console.log('storeOffsetHeight');
      if (me.$parent && me.$parent.$parent && me.$parent.$parent.$parent.$parent && me.$parent.$parent.$parent.$parent.$refs && me.$parent.$parent.$parent.$parent.$refs.iScroll && me.$parent.$parent.$parent.$parent.$refs.iScroll.refresh) {
        var storeOffsetHeight = 0;

        var hd = setInterval(function () {
          var offsetHeight = _this.$refs.notice ? _this.$refs.notice.offsetHeight : 0;
          if (storeOffsetHeight != offsetHeight) {
            storeOffsetHeight = offsetHeight;
            me.$parent.$parent.$parent.$parent.$refs.iScroll.refresh();
          }
        }, 1000);
        setTimeout(function () {
          clearInterval(hd);
        }, 12000);
      }
    });
  }
});

/***/ }),

/***/ "Aee5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/vip-dialog-icon.e140e29.png";

/***/ }),

/***/ "Apws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUUID */
/* harmony export (immutable) */ __webpack_exports__["c"] = report;
/* harmony export (immutable) */ __webpack_exports__["a"] = getServiceQRCode;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nanoid__ = __webpack_require__("NfQX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_config__ = __webpack_require__("13m2");




var _this = this;





var getUUID = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var storageUUID, uuid, res;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            storageUUID = localStorage.getItem('UUID');

            if (!storageUUID) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', storageUUID);

          case 3:
            uuid = '';

            if (!(window.jsBridge && window.jsBridge.isApp)) {
              _context.next = 11;
              break;
            }

            _context.next = 7;
            return window.jsBridge.getAppInfo();

          case 7:
            res = _context.sent;

            uuid = res.udid;
            _context.next = 12;
            break;

          case 11:
            uuid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_nanoid__["a" /* nanoid */])();

          case 12:

            localStorage.setItem('UUID', uuid);

            return _context.abrupt('return', uuid);

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getUUID() {
    return _ref.apply(this, arguments);
  };
}();

function report(params) {
  var _this2 = this;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
      var uuid;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getUUID();

            case 2:
              uuid = _context2.sent;


              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])({
                url: __WEBPACK_IMPORTED_MODULE_5__commons_config__["b" /* requestUrl */].report,
                type: 'post',
                params: params,
                headers: {
                  'x-version': '1.0.1',
                  'x-app-id': 'GhustWIe32t7smS3',
                  'x-udid': uuid
                },
                success: function success(datas) {
                  resolve(datas);
                }
              });

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
}

function getServiceQRCode() {
  var _this3 = this;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])({
                url: ' https://common-open-api.jin10.com/configuration/getById',
                type: 'GET',
                headers: {
                  'x-version': '1.0.0',
                  'x-app-id': 'zP6WFH7WKz2vrw4Q'
                },
                params: {
                  id: 1176
                },
                success: function success(datas) {
                  resolve(datas);
                }
              });

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }));

    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }());
}

function getConfig(params) {
  var _this4 = this;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])({
                url: 'https://common-open-api.jin10.com/configuration/getById',
                type: 'GET',
                params: params,
                headers: {
                  'x-version': '1.0.0',
                  'x-app-id': 'zP6WFH7WKz2vrw4Q'
                },
                success: function success(datas) {
                  resolve(datas);
                }
              });

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }));

    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }());
}

/***/ }),

/***/ "B8lz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/tv_qrcode.961f7d2.png";

/***/ }),

/***/ "BgJU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (this.jsBridge.isApp) {
      this.jsBridge.dispatch('hideAppNavbar', { isOnlyGoBackWeb: '0' });
      this.jsBridge.dispatch('setAppStatusBarColor', '0');
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['pageType']), {
    headerTitle: function headerTitle() {
      return {
        vip: 'VIP会员直播',
        tradingNew: '同声传译'
      }[this.pageType];
    }
  }),
  methods: {
    onBack: function onBack() {
      this.jsBridge.dispatch('goBackApp');
    },
    onShare: function onShare() {
      this.jsBridge.dispatch('appShare');
    }
  }
});

/***/ }),

/***/ "CeuU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_vue__ = __webpack_require__("yOKL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_main_vue__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_vue___default.a);

/***/ }),

/***/ "D3kI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var bindGlassEffectMixin = function bindGlassEffectMixin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { type: 'black', multiple: false };

  return {
    data: function data() {
      return {
        bindInstance: null,
        bindInstanceMap: {}
      };
    },

    methods: {
      bindGlassEffect: function bindGlassEffect(el) {
        var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : options;

        var key = arguments[2];
        var bindGlassEffect = window['new-layout-commonComponent'].bindGlassEffect;


        if (!options.multiple) {
          if (el && !this.bindInstance) {
            this.bindInstance = bindGlassEffect(el, _options);
          }
        } else if (el && !this.bindInstanceMap[key]) {
          this.bindInstanceMap[key] = bindGlassEffect(el, _options);
        }
      },
      unbindGlassEffect: function unbindGlassEffect(key) {
        if (options.multiple) {
          this.bindInstanceMap[key] && this.bindInstanceMap[key].unbind();
          delete this.bindInstanceMap[key];
        } else {
          this.bindInstance && this.bindInstance.unbind();
        }
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.unbindGlassEffect();
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (bindGlassEffectMixin);

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_LIVE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_LIVE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_LIVE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_FETCH_APP_USER_DATA_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_LIVE_CURRENT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_CHANNEL_LIVE_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_CHAT_READY_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHECK_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SERVER_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_POSTER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_EMCEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_VIDEO_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_TRADING_VIDEO_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_PREVUE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_FM_LIVE_PLAY_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_FM_REPLAY_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_FM_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_FM_EMMEC_NOTICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPDATE_FM_SIGN_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_WEEK_TALK_DATAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_PAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_VIP_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_TRY_FREE_REMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_SERVICE_QRCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_LOCAL_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_TOP_NAVS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_WINDOW_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_HAS_BUY_DING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_HAS_GET_DING_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_DING_SHOW_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return UPDATE_ROOM_INFO; });
var UPDATE_OPTIONS = 'UPDATE_OPTIONS';
var UPDATE_USER = 'UPDATE_USER';
var UPDATE_LIVE_TYPE = 'UPDATE_LIVE_TYPE';
var UPDATE_LIVE_INFO = 'UPDATE_LIVE_INFO';
var UPDATE_LIVE_URL = 'UPDATE_LIVE_URL';
var UPDATE_FETCH_APP_USER_DATA_STATE = 'UPDATE_FETCH_APP_USER_DATA_STATE';
var UPDATE_LIVE_CURRENT_STATE = 'UPDATE_LIVE_CURRENT_STATE';
var UPDATE_CHANNEL_LIVE_STATE = 'UPDATE_CHANNEL_LIVE_STATE';
var UPDATE_CHAT_READY_STATE = 'UPDATE_CHAT_READY_STATE';
var CHECK_DEVICE = 'CHECK_DEVICE';
var UPDATE_SERVER_TIME = 'UPDATE_SERVER_TIME';
var UPDATE_POSTER_URL = 'UPDATE_POSTER_URL';
var UPDATE_EMCEE = 'UPDATE_EMCEE';
var UPDATE_VIDEO_ID = 'UPDATE_VIDEO_ID';
var UPDATE_TRADING_VIDEO_ID = 'UPDATE_TRADING_VIDEO_ID';
var UPDATE_PREVUE_TIME = 'UPDATE_PREVUE_TIME';

var UPDATE_FM_LIVE_PLAY_STATE = 'UPDATE_FM_LIVE_PLAY_STATE';
var UPDATE_FM_REPLAY_STATE = 'UPDATE_FM_REPLAY_STATE';
var UPDATE_FM_VIDEO = 'UPDATE_FM_VIDEO';
var UPDATE_FM_EMMEC_NOTICE = 'UPDATE_FM_EMMEC_NOTICE';
var UPDATE_FM_SIGN_VISIBLE = 'UPDATE_FM_SIGN_VISIBLE';

var UPDATE_WEEK_TALK_DATAS = 'UPDATE_WEEK_TALK_DATAS';

var SET_PAGE_TYPE = 'SET_PAGE_TYPE';
var SET_VIP_STATE = 'SET_VIP_STATE';

var SET_TRY_FREE_REMAIN = 'SET_TRY_FREE_REMAIN';
var SET_SERVICE_QRCODE = 'SET_SERVICE_QRCODE';
var SET_LOCAL_TIME = 'SET_LOCAL_TIME';
var SET_TOP_NAVS = 'SET_TOP_NAVS';
var SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH';
var SET_HAS_BUY_DING = 'SET_HAS_BUY_DING';
var SET_HAS_GET_DING_INFO = 'SET_HAS_GET_DING_INFO';
var SET_DING_SHOW_CONFIG = 'SET_DING_SHOW_CONFIG';
var UPDATE_ROOM_INFO = 'UPDATE_ROOM_INFO';

/***/ }),

/***/ "FD4Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/trading_qrcode.30d2ca7.png";

/***/ }),

/***/ "FbZm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUS", function() { return BUS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_element_ui__ = __webpack_require__("VJSc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_base_component__ = __webpack_require__("P03V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("8oQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base__ = __webpack_require__("DfDl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules__ = __webpack_require__("QwkV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__front_end_utils_lib_loadResource__ = __webpack_require__("telC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__front_end_utils_lib_loadResource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__front_end_utils_lib_loadResource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__statics__ = __webpack_require__("qd8w");















window._babelPolyfill = false;
var vm = null;

var BUS = new __WEBPACK_IMPORTED_MODULE_2_vue___default.a();
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$bus = BUS;

var init = function init() {
  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.config.productionTip = false;
  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8__modules__["a" /* default */]);
  window.JIN10_APP.VueComponents(__WEBPACK_IMPORTED_MODULE_2_vue___default.a);
  vm = new __WEBPACK_IMPORTED_MODULE_2_vue___default.a({
    router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]
  }).$mount('#J_tv');
  vm.$router.beforeEach(function (to, from, next) {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    vm.$loadingBar.start();
    next();
  });
  vm.$router.afterEach(function () {
    vm.$loadingBar.finish();
  });
};
var cdnBase = '//cdn.jin10.com/components/v1';
__WEBPACK_IMPORTED_MODULE_9__front_end_utils_lib_loadResource___default()([cdnBase + '/new-layout-common/index.js?v=' + window.FE_COMP_TIME_VER, cdnBase + '/new-layout-common/index.css?v=' + window.FE_COMP_TIME_VER, cdnBase + '/header-new/index.js?v=' + window.FE_COMP_TIME_VER, cdnBase + '/header-new/index.css?v=' + window.FE_COMP_TIME_VER, cdnBase + '/footer-new/index.js?v=' + window.FE_COMP_TIME_VER, cdnBase + '/footer-new/index.css?v=' + window.FE_COMP_TIME_VER, cdnBase + '/glass-btn/index.js?v=' + window.FE_COMP_TIME_VER, cdnBase + '/glass-btn/index.css?v=' + window.FE_COMP_TIME_VER], { returnPromise: true }).then(function () {
  function registerAsyncComponent(tagName, windowKey) {
    __WEBPACK_IMPORTED_MODULE_2_vue___default.a.component(tagName, function () {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        function tryResolve() {
          var comp = window[windowKey];
          if (comp) {
            resolve(comp);
          } else {
            setTimeout(tryResolve, 100);
          }
        }
        tryResolve();
      });
    });
  }
  var registerDirectives = function registerDirectives() {
    var layoutCommon = window['new-layout-commonComponent'];
    console.log('layoutCommon', layoutCommon);
    if (layoutCommon && layoutCommon.glassDirective) {
      __WEBPACK_IMPORTED_MODULE_2_vue___default.a.directive('glass', layoutCommon.glassDirective);
      __WEBPACK_IMPORTED_MODULE_2_vue___default.a.directive('dark-mask', layoutCommon.darkMaskDirective);
    } else {
      setTimeout(registerDirectives, 100);
    }
  };
  registerDirectives();
  registerAsyncComponent('glass-btn', 'glass-btnComponent');
  registerAsyncComponent('footer-new', 'footer-newComponent');
  registerAsyncComponent('header-new', 'header-newComponent');
  if (false) {
    window.Vue = Vue;
    loadResource(['//cdn.jin10.com/assets/js/vue-components/js/index.js'], { returnPromise: true }).then(function () {
      init();
    });
  } else {
    init();
  }
});

var privateType = '303ccae79fc4661d';
var playState = function playState(options) {
  var type = vm.$route.meta.type || window._videoType;
  if (type !== privateType && options.type === privateType) {
    return false;
  }
  if (!type && options.type === 'tradingNew') {
    return false;
  }
  if (type && type !== options.type) {
    return false;
  }
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setLiveUrl', options.url);
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setLiveType', options.type);
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setEmcee', options.emcee);
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setVideoID', options.id);
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setTradingVideoID', options.id);
  return true;
};

window.showImage = function (a, options) {
  var params = {
    url: false
  };
  if (!playState(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(options, params))) {
    return false;
  }
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setPosterUrl', __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.liveInfo.overImg);
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setLiveState', false);
};

window.showLive = function (a, options) {
  var params = {
    url: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.isMobile ? options.url : options.url_flv
  };
  if (!playState(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(options, params))) {
    return false;
  }
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setLiveState', true);
};

window.showRepeat = function (a, options) {
  var params = {
    url: options.repeat_url
  };
  if (!playState(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(options, params))) {
    return false;
  }
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setLiveState', false);
};

/***/ }),

/***/ "Fcz0":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-play-box tv-video"
  }, [(_vm.pageType !== 'vip') ? _c('div', {
    staticClass: "jin-play-box__h"
  }, [_c('div', {
    staticClass: "jin-play-box__l"
  }, [_c('h3', {
    staticClass: "jin-play-box__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "jin-play-box__r"
  }, [_c('jin-popover', {
    ref: "qrcodePopover",
    attrs: {
      "popper-class": "jin-qrcode-popover",
      "placement": "bottom-end",
      "open-delay": 300,
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "jin-qrcode"
  }, [_c('dl', [_c('dt', [_c('p', [_vm._v("扫描右侧二维码")]), _vm._v(" "), _c('p', [_vm._v("畅享手机看直播")])]), _vm._v(" "), _c('dd', [(_vm.liveType === 'tradingNew') ? _c('img', {
    attrs: {
      "src": __webpack_require__("FD4Q")
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__("B8lz")
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:qrcodePopover",
      arg: "qrcodePopover"
    }],
    staticClass: "jin-play-box__btn jin-play-box__phone"
  }, [_c('icon', {
    attrs: {
      "type": "phone"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tv-video__b"
  }, [(!_vm.repeatImageUrl) ? [(_vm.liveUrl) ? _c('div', [(_vm.isMobile) ? _c('div', {
    staticClass: "tv-video__box"
  }, [_c('video', {
    attrs: {
      "id": "J_tv_video_type",
      "width": "100%",
      "height": "100%",
      "controls": "controls",
      "webkit-playsinline": "",
      "playsinline": "",
      "x-webkit-airplay": "allow",
      "x5-playsinline": "",
      "autoplay": "autoplay"
    }
  })]) : _c('div', {
    staticClass: "tv-video__box",
    attrs: {
      "id": "J_tv_box_type"
    }
  })]) : _c('div', {
    staticClass: "tv-video__poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.posterUrl
    }
  })])] : _c('div', {
    staticClass: "tv-video__poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.repeatImageUrl
    }
  }), _vm._v(" "), (_vm.repeatImageUrl && _vm.isVipPageAndNotAVip) ? _c('a', {
    staticClass: "tv-video__vip-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toVipPage
    }
  }) : _c('jin-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showRepeat
    }
  }, [_c('icon', {
    attrs: {
      "type": "repeat-video"
    }
  }), _vm._v(" "), _c('span', [_vm._v("点击这里收看最近一期节目")])], 1)], 1), _vm._v(" "), (_vm.isShowNextTV && false) ? _c('div', {
    staticClass: "tv-video__mask"
  }, [_c('div', {
    staticClass: "tv-video-tips"
  }, [_c('h4', {
    staticClass: "tv-video-tips__h"
  }, [_vm._v("\n          温馨提示：" + _vm._s(_vm.nowDatas.prevue.title) + "即将直播\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-tips__b"
  }, [_c('jin-button', {
    on: {
      "click": _vm.closeNextTV
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('jin-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showNextTV
    }
  }, [_vm._v("提前进入")])], 1)])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tv-video__f"
  }, [_c('div', {
    staticClass: "tv-video__l"
  }, [_c('div', {
    staticClass: "tv-video-info"
  }, [(_vm.getEmceeInfo('pic')) ? _c('img', {
    staticClass: "tv-video-info__avatar",
    attrs: {
      "src": _vm.getEmceeInfo('pic'),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('nick')) ? _c('span', {
    staticClass: "tv-video-info__text"
  }, [_vm._v("关注" + _vm._s(_vm.getEmceeInfo('nick')))]) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('weibo')) ? _c('a', {
    staticClass: "tv-video-info__btn is-weibo",
    attrs: {
      "target": "_blank",
      "href": _vm.getEmceeInfo('weibo')
    }
  }, [_c('icon', {
    attrs: {
      "type": "weibo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('jin-popover', {
    ref: "wechatPopover",
    attrs: {
      "placement": "right",
      "trigger": "hover"
    }
  }, [_c('img', {
    attrs: {
      "width": "200",
      "src": _vm.wechatUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "popover",
      rawName: "v-popover:wechatPopover",
      arg: "wechatPopover"
    }],
    staticClass: "tv-video-info__btn is-wechat"
  }, [(_vm.wechatUrl) ? _c('icon', {
    attrs: {
      "type": "wechat"
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share"
  }, [_c('share-button', {
    attrs: {
      "dir": "vertical"
    }
  })], 1)]), _vm._v(" "), _c('vip-dialog', {
    model: {
      value: (_vm.showVipDialog),
      callback: function($$v) {
        _vm.showVipDialog = $$v
      },
      expression: "showVipDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "Gi4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");







/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['topNavs']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['options', 'liveType']), {
    list: function list() {
      return this.options.newsConfig || {};
    },
    style: function style() {
      if (this.paddingTop) {
        return {
          paddingTop: this.paddingTop
        };
      }
    }
  }),
  watch: {
    liveType: function liveType(v) {
      this.type = v;
      this.getDatas(v);
    },
    type: function type(v) {
      var el = this.$refs['nav-' + v] && this.$refs['nav-' + v][0];
      if (el) {
        var wrap = this.$refs.navWrap;
        var wrapWidth = wrap.offsetWidth;
        var wrapScrollLeft = wrap.scrollLeft;
        var elWidth = el.offsetWidth;
        var elLeft = el.offsetLeft;
        var elRight = elLeft + elWidth;
        var wrapRight = wrapWidth + wrapScrollLeft;
        if (elLeft < wrapScrollLeft) {
          wrap.scrollLeft = elLeft;
        } else if (elRight > wrapRight) {
          wrap.scrollLeft = elRight - wrapWidth;
        }
      }
    }
  },
  data: function data() {
    return {
      inited: false,
      isLoading: false,
      timer: null,
      datas: [],
      type: '',
      id: 21,
      paddingTop: 0
    };
  },
  created: function created() {
    window.addEventListener('resize', this.resizeHandle, false);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resizeHandle, false);
  },

  methods: {
    getDatas: function getDatas(type) {
      var _this = this;

      if (this.isLoading) {
        return false;
      }
      var id = this.list[type];
      this.isLoading = true;
      this.type = id ? type : 'tv';
      this.id = id || 21;
      this.datas = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_fetch__["a" /* fetch */])({
        type: 'jsonp',
        url: __WEBPACK_IMPORTED_MODULE_3__commons_config__["b" /* requestUrl */].history,
        params: {
          id: this.id
        },
        callback: function callback() {
          _this.isLoading = false;
        },
        success: function success(_ref) {
          var data = _ref.data;

          if (!data.length) {
            return false;
          }
          data.length = 3;
          _this.datas = data.map(function (item) {
            if (!item.thumb.includes('/lite')) item.thumb = item.thumb + '/lite';
            if (!item.thumb_mobile.includes('/lite')) item.thumb = item.thumb_mobile + '/lite';
            return item;
          });


          if (!_this.inited) {
            _this.$nextTick(function () {
              _this.calculateThePadding();
              _this.inited = true;
            });
          }
        },
        error: function error() {
          _this.isLoading = false;
        }
      });
    },
    calculateThePadding: function calculateThePadding() {
      var _this2 = this;

      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        var $el = _this2.$refs.box;
        _this2.paddingTop = $el.offsetHeight / $el.offsetWidth * 100 + '%';
      }, 200);
    },
    resizeHandle: function resizeHandle() {
      this.calculateThePadding();
    },
    getNavTitle: function getNavTitle(key) {
      var findNav = this.topNavs.find(function (item) {
        return item.type === key;
      });
      return (findNav ? findNav.name : '') || this.options[key].title;
    }
  }
});

/***/ }),

/***/ "IJUa":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-notice jin-side-notice"
  }, [_c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('h3', {
    staticClass: "jin-side-notice__h"
  }, [_vm._v("\n    《金十交易现场》英文-中文同声传译\n    ")]), _vm._v(" "), (_vm.countdownTime && !_vm.isLive) ? _c('div', {
    staticClass: "jin-side-notice__countdown"
  }, [_c('icon', {
    attrs: {
      "type": "countdown"
    }
  }), _vm._v(" "), _c('span', [_vm._v("距离下一个节目直播还有 ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.countdownTime))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jin-side-notice__time"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title is-inline"
  }, [_vm._v("直播时间")]), _vm._v(" "), (_vm.datas.date) ? _c('p', [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.datas.date, 'yyyy年MM月dd日hh:mm:ss')) + "（北京时间）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__figure"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title"
  }, [_vm._v("本次讲话出场人物")]), _vm._v(" "), _c('ul', {
    staticClass: "jin-side-notice__list"
  }, _vm._l((_vm.datas.guest), function(name, index) {
    return _c('li', {
      key: index,
      staticClass: "jin-side-notice__imgText is-inline"
    }, [_c('img', {
      attrs: {
        "src": ("//tv.jin10.com/assets/img/trading/figure/" + name + ".jpg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(name))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__intro"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title"
  }, [_vm._v("当前节目主题介绍")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.datas.memo))])])]), _vm._v(" "), (_vm.datas.interpreter) ? _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__figure"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title"
  }, [_vm._v("Ta正在为您同传")]), _vm._v(" "), _c('ul', {
    staticClass: "jin-side-notice__list"
  }, _vm._l((_vm.datas.interpreter), function(name, index) {
    return _c('li', {
      key: index,
      staticClass: "jin-side-notice__imgText is-inline"
    }, [_c('img', {
      attrs: {
        "src": ("//tv.jin10.com/assets/img/trading/interpreter/" + name + ".png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(name))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__intro"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title"
  }, [_vm._v("栏目介绍")]), _vm._v(" "), _c('p', [_vm._v("我们是金十小黑屋同传，致力于为您提供美联储主席鲍威尔、欧洲央行行长德拉基、“债王”格罗斯、“股神”巴菲特等大佬讲话的现场直播。交易世界，分秒必争，来交易现场体验没有时差阻隔、没有语言障碍的同传直播。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__qrcode"
  }, [_c('p', [_vm._v("请关注我们的公众号（仅面向专业用户）")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//tv.jin10.com/assets/img/trading/jiaoyuwechat.jpg",
      "alt": ""
    }
  })])])
}]}

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_guess__ = __webpack_require__("P2kB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_utils__ = __webpack_require__("j+bc");










if (false) {
  Vue.use(Vuex);
}

var state = {
  user: {},

  options: {},
  isMobile: false,
  isLive: false,
  isFetchAppUserData: false,
  channelLiveState: {},
  liveUrl: '',
  liveType: '',
  liveInfo: {},
  posterUrl: '',
  chatReadyState: false,
  serverTime: null,
  prevueTime: null,
  emcee: null,
  tradingVideoID: '',
  videoID: '',

  fmLivePlayState: true,
  fmReplayState: false,
  fmVideo: {
    isShow: false,
    url: ''
  },
  fmEmmecNotice: '',
  isShowFMSign: false,

  weekTalkDatas: {},

  pageType: '',

  isEliteVip: false,

  isVip: false,

  isBlackGoldVip: false,

  isYearVip: false,

  isSuperVip: false,
  hasGetUser: false,
  hasGetOptions: false,

  trySeeRemain: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__commons_utils__["a" /* getTrySeeCache */])(),

  serviceQRCodeConfig: [],
  localTime: Date.now(),

  topNavs: [],
  windowWidth: window.innerWidth,
  hasBuyDing: false,
  hasGetDingInfo: false,
  hasGetDingShowConfig: false,
  dingShowConfig: {
    roomName: '',
    show: false
  },
  chatRooms: {}
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: {
    guess: __WEBPACK_IMPORTED_MODULE_5__modules_guess__["a" /* default */]
  }
}));

/***/ }),

/***/ "JH/5":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("LeLA")
  __webpack_require__("tn2w")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Uie7"),
  /* template */
  __webpack_require__("Ja+B"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-760d7c20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Ja+B":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-play-box tv-video"
  }, [_c('div', {
    staticClass: "jin-play-box__h"
  }, [_c('div', {
    staticClass: "jin-play-box__l"
  }, [_c('live-staus-tag', {
    attrs: {
      "preview": _vm.hasPreviewVideo,
      "repeat": _vm.isPlayingRepeat,
      "live": _vm.isLive
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "jin-play-box__title"
  }, [_vm._v(_vm._s(_vm.customTitle || _vm.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "jin-play-box__r"
  }, [_c('el-popover', {
    ref: "phoneSharePopover",
    attrs: {
      "trigger": "hover",
      "placement": "bottom-end",
      "popper-class": "glass-popover glass-effect is-black",
      "visible-arrow": false
    },
    on: {
      "show": function($event) {
        return _vm.onPopoverShow('phoneSharePopover')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [(_vm.liveType === 'tradingNew') ? _c('img', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "width": "120",
      "src": __webpack_require__("FD4Q")
    }
  }) : _c('img', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "width": "120",
      "src": __webpack_require__("B8lz")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "text-align": "center",
      "font-size": "14px",
      "font-weight": "bold",
      "color": "var(--on-surface)",
      "user-select": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "line-height": "normal"
    }
  }, [_vm._v("\n              扫描右侧二维码\n              "), _c('br'), _vm._v("\n              畅享手机看直播\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "jin-play-box__btn jin-play-box__phone",
    staticStyle: {
      "color": "var(--on-surface)"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('PhoneSvg', {
    attrs: {
      "size": 32
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tv-video__b"
  }, [((_vm.isTrySee || (_vm.isRepeatTrySee && _vm.isPlayingRepeat))) ? [(_vm.isLive ? !_vm.isTrySeeEnd : !_vm.isRepeatTrySeeEnd) ? [(_vm.isMobile) ? [_c('div', {
    staticClass: "try-free-tips",
    class: {
      'svip-only': _vm.liveRoleType === _vm.LIVE_ROLE_TYPE.svip || _vm.repeatRoleType === _vm.LIVE_ROLE_TYPE.svip,
      'vip-only': _vm.liveRoleType === _vm.LIVE_ROLE_TYPE.vip || _vm.repeatRoleType === _vm.LIVE_ROLE_TYPE.vip,
    },
    on: {
      "click": _vm.toVipPage
    }
  }, [_vm._v("\n            此为试看版，"), _c('span', [_vm._v("购买")]), _c('div', {
    staticClass: "logo"
  }), _vm._v(" 观看完整版\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "try-free-top",
    class: {
      'svip': _vm.liveRoleType === _vm.LIVE_ROLE_TYPE.svip || _vm.repeatRoleType === _vm.LIVE_ROLE_TYPE.svip,
      'vip': _vm.liveRoleType === _vm.LIVE_ROLE_TYPE.vip || _vm.repeatRoleType === _vm.LIVE_ROLE_TYPE.vip,
      'is-mobile': _vm.isMobile
    },
    on: {
      "click": _vm.toVipPage
    }
  })] : _vm._e()] : [_c('div', {
    staticClass: "try-see-end"
  }, [_c('p', [_vm._v("该" + _vm._s(_vm.isLive ? '直播' : '视频') + "为VIP" + _vm._s(_vm.isLive ? '直播' : '重播') + "，试看已结束")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.toVipPage
    }
  }, [_vm._v("立即成为VIP")])])]] : _vm._e(), _vm._v(" "), (!_vm.repeatImageUrl) ? [(_vm.liveUrl) ? [(_vm.liveUrl) ? [(_vm.isMobile) ? _c('div', {
    staticClass: "tv-video__box"
  }, [_c('video', {
    attrs: {
      "id": "J_tv_video",
      "width": "100%",
      "height": "100%",
      "controls": "controls",
      "webkit-playsinline": "",
      "playsinline": "",
      "x-webkit-airplay": "allow",
      "x5-playsinline": "",
      "autoplay": "autoplay"
    }
  })]) : _c('div', {
    staticClass: "tv-video__box",
    attrs: {
      "id": "J_tv_box"
    }
  })] : _c('img', {
    staticClass: "tv-video__poster live",
    attrs: {
      "src": _vm.poster
    }
  })] : (_vm.hasPreviewVideo) ? _c('div', [(_vm.isMobile) ? _c('div', {
    staticClass: "tv-video__box"
  }, [_c('video', {
    attrs: {
      "id": "J_tv_video",
      "width": "100%",
      "height": "100%",
      "controls": "controls",
      "webkit-playsinline": "",
      "playsinline": "",
      "x-webkit-airplay": "allow",
      "x5-playsinline": "",
      "autoplay": "autoplay"
    }
  })]) : _c('div', {
    staticClass: "tv-video__box preview",
    attrs: {
      "id": "J_tv_box"
    }
  })]) : _c('div', {
    staticClass: "tv-video__poster preview",
    class: {
      trading: _vm.isTradingPageAndNotAVip
    },
    on: {
      "click": function () {
        _vm.isTradingPageAndNotAVip && _vm.toVipPage()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.posterUrl
    }
  })])] : _c('div', {
    staticClass: "tv-video__poster repeat",
    class: {
      trading: _vm.isTradingPageAndNotAVip
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.repeatImageUrl
    }
  }), _vm._v(" "), (_vm.repeatImageUrl && _vm.isTradingPageAndNotAVip) ? _c('a', {
    staticClass: "tv-video__vip-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toVipPage
    }
  }) : _vm._e(), _vm._v(" "), _c('glass-btn', {
    attrs: {
      "round": "",
      "type": "default"
    },
    on: {
      "click": _vm.showRepeat
    }
  }, [_c('PlayLineSvg'), _vm._v(" "), _c('span', [_vm._v("点击这里收看最近一期节目")])], 1)], 1), _vm._v(" "), (_vm.isShowNextTV && false) ? _c('div', {
    staticClass: "tv-video__mask"
  }, [_c('div', {
    staticClass: "tv-video-tips"
  }, [_c('h4', {
    staticClass: "tv-video-tips__h"
  }, [_vm._v("\n          温馨提示：" + _vm._s(_vm.nowDatas.prevue.title) + "即将直播\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-tips__b"
  }, [_c('jin-button', {
    on: {
      "click": _vm.closeNextTV
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('jin-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showNextTV
    }
  }, [_vm._v("提前进入")])], 1)])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tv-video__f"
  }, [_c('div', {
    staticClass: "tv-video__l"
  }, [_c('div', {
    staticClass: "tv-video-info"
  }, [(_vm.getEmceeInfo('pic')) ? _c('img', {
    staticClass: "tv-video-info__avatar",
    attrs: {
      "src": _vm.getEmceeInfo('pic'),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('nick')) ? _c('span', {
    staticClass: "tv-video-info__text"
  }, [_vm._v(_vm._s(_vm.getEmceeInfo('nick')))]) : _vm._e(), _vm._v(" "), (_vm.wechatUrl) ? _c('el-popover', {
    ref: "weixinFollowPopover",
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "popper-class": "glass-popover glass-effect is-black",
      "visible-arrow": false
    },
    on: {
      "show": function($event) {
        return _vm.onPopoverShow('weixinFollowPopover')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('img', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "width": "120",
      "src": _vm.wechatUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "text-align": "center",
      "font-size": "14px",
      "font-weight": "bold",
      "color": "var(--on-surface)",
      "user-select": "none"
    }
  }, [_vm._v("微信扫一扫关注")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "glass",
      rawName: "v-glass",
      value: ({
        type: 'btnNormal'
      }),
      expression: "{type: 'btnNormal'}"
    }],
    staticClass: "tv-video-info__btn",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('WeixinSvg')], 1)]) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('weibo')) ? _c('a', {
    directives: [{
      name: "glass",
      rawName: "v-glass",
      value: ({
        type: 'btnNormal'
      }),
      expression: "{type: 'btnNormal'}"
    }],
    staticClass: "tv-video-info__btn is-weibo",
    attrs: {
      "target": "_blank",
      "href": _vm.getEmceeInfo('weibo')
    }
  }, [_c('WeiboSvg')], 1) : _vm._e(), _vm._v(" "), (_vm.wechatUrl || _vm.getEmceeInfo('weibo')) ? _c('base-divider') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "glass",
      rawName: "v-glass",
      value: ({
        type: 'btnNormal'
      }),
      expression: "{ type: 'btnNormal' }"
    }],
    staticClass: "tv-video-info__attention",
    class: {
      'is-follow': _vm.follow
    },
    on: {
      "click": _vm.onAttend
    }
  }, [(!_vm.follow) ? _c('PlusSvg') : _vm._e(), _vm._v("\n          " + _vm._s(_vm.follow ? '已关注' : '关注') + "\n        ")], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share"
  }, [_c('div', {
    staticClass: "tv-video-share__label"
  }, [_c('ShareSvg'), _vm._v("\n        分享：\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share__btn-group"
  }, [_c('a', {
    staticClass: "tv-video-share__btn",
    attrs: {
      "target": "_blank",
      "href": "https://connect.qq.com/widget/shareqq/index.html?url=https%3A%2F%2Ftv.jin10.com%2F%23%2F&title=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&source=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&desc=%E9%87%91%E5%8D%81TV%E6%89%BF%E8%BD%BD%E7%9B%B4%E6%92%AD%E8%8A%82%E7%9B%AE%EF%BC%8C%E5%AE%9E%E6%97%B6%E7%95%99%E8%A8%80%E4%BA%92%E5%8A%A8%E3%80%82%E5%9C%A8TV%E9%A1%B5%E9%9D%A2%E6%82%A8%E5%B0%86%E7%AC%AC%E4%B8%80%E6%97%B6%E9%97%B4%E8%A7%82%E7%9C%8B%E5%88%B0%E9%87%91%E5%8D%81%E6%97%A9%E7%9F%A5%E9%81%93%E3%80%81%E7%8E%AF%E7%90%83%E8%BE%9B%E8%AF%B4%E3%80%81%E9%87%91%E5%8D%81%E5%90%8C%E4%BC%A0%E5%A3%B0%E8%AF%91%E7%AD%89%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD%EF%BC%8C%E9%94%81%E5%AE%9A%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD%E9%A2%84%E5%91%8A%EF%BC%8C%E8%8E%B7%E5%8F%96%E5%B9%B2%E8%B4%A7%E5%88%86%E7%A7%92%E5%BF%85%E4%BA%89%E3%80%82&pics=https%3A%2F%2Fimages.jin10.com%2Favatar%2F8dfe8fb5-01ff-48c2-a824-2f43677d9548.png%2Flite"
    }
  }, [_c('QqSvg')], 1), _vm._v(" "), _c('a', {
    staticClass: "tv-video-share__btn",
    attrs: {
      "target": "_blank",
      "href": "http://service.weibo.com/share/share.php?url=https%3A%2F%2Ftv.jin10.com%2F%23%2F&title=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&pic=https%3A%2F%2Fimages.jin10.com%2Favatar%2F8dfe8fb5-01ff-48c2-a824-2f43677d9548.png%2Flite&appkey="
    }
  }, [_c('WeiboSlimSvg', {
    attrs: {
      "size": 24
    }
  })], 1), _vm._v(" "), _c('el-popover', {
    ref: "weixinSharePopover",
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "popper-class": "glass-popover glass-effect is-black",
      "visible-arrow": false
    },
    on: {
      "show": function($event) {
        return _vm.onPopoverShow('weixinSharePopover')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('WexinShareQrcode'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "text-align": "center",
      "font-size": "14px",
      "font-weight": "bold",
      "color": "var(--on-surface)",
      "user-select": "none"
    }
  }, [_vm._v("微信扫一扫分享")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share__btn",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('WeixinSlimSvg', {
    attrs: {
      "size": 24
    }
  })], 1)])], 1)])]), _vm._v(" "), _c('vip-dialog', {
    model: {
      value: (_vm.showVipDialog),
      callback: function($$v) {
        _vm.showVipDialog = $$v
      },
      expression: "showVipDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "KVJS":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-content"
  }, [_c('div', {
    staticClass: "jin-main"
  }, [(_vm.isType) ? _c('CVideoForType') : _vm._e(), _vm._v(" "), _c('c-video'), _vm._v(" "), _c('related-recommend')], 1), _vm._v(" "), _c('c-side', {
    ref: "side"
  }, [(_vm.isTrading) ? _c('c-trading-notice', {
    on: {
      "update": _vm.updateTradingNotice
    }
  }) : _c('c-notice')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "LDL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (this.jsBridge.isApp) {
      this.jsBridge.dispatch('hideAppNavbar', { isOnlyGoBackWeb: '0' });
      this.jsBridge.dispatch('setAppStatusBarColor', '0');
    }
  },

  methods: {
    onBack: function onBack() {
      this.jsBridge.dispatch('goBackApp');
    },
    onShare: function onShare() {

      this.jsBridge.dispatch('appShare');
    }
  }
});

/***/ }),

/***/ "LI1s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_config__ = __webpack_require__("13m2");








/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['tradingVideoID', 'prevueTime', 'serverTime', 'isLive'])),
  data: function data() {
    return {
      datas: {},
      isLoading: false,
      countdownTime: '',
      timer: null,
      inited: false,
      loaded: false
    };
  },

  watch: {
    tradingVideoID: function tradingVideoID(v) {
      if (v) {
        this.getNotice(v);
      }
    },
    prevueTime: function prevueTime(v) {
      if (v && !this.inited) {
        this.countdown();
        this.inited = true;
      }
    },
    $route: function $route() {
      this.$store.dispatch('setTradingVideoID', 0);
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.datas).length) {
        _this.getNotice(_this.tradingVideoID);
      }
    }, 1000);
  },

  methods: {
    getNotice: function getNotice(id) {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_fetch__["a" /* fetch */])({
        type: 'jsonp',
        url: __WEBPACK_IMPORTED_MODULE_4__commons_config__["b" /* requestUrl */].detail,
        params: {
          id: id
        },
        callback: function callback() {
          _this2.isLoading = false;
        },
        success: function success(_ref) {
          var data = _ref.data;

          _this2.datas = data;
          _this2.$nextTick(function () {
            _this2.$emit('update');
          });
        },
        error: function error() {
          _this2.isLoading = false;
        }
      });
    },
    freshTime: function freshTime(endtime) {
      endtime = new Date(endtime);
      var nowtime = new Date();
      var lefttime = parseInt((endtime.getTime() - nowtime.getTime()) / 1000);
      var time = '';
      var d = parseInt(lefttime / 24 / 60 / 60);
      var h = parseInt(lefttime / (60 * 60) % 24);
      var m = parseInt(lefttime / 60 % 60);
      var s = parseInt(lefttime % 60);
      if (s < 10) {
        s = '0' + s;
      }
      time = '' + (d ? d + '\u5929' : '') + h + '\u5C0F\u65F6' + m + '\u5206' + s + '\u79D2';
      if (lefttime <= 0) {
        clearInterval(this.timer);
        time = '';
      }
      this.countdownTime = time;
    },
    countdown: function countdown() {
      var _this3 = this;

      this.timer = setInterval(function () {
        _this3.freshTime(_this3.prevueTime.replace(/-/g, '/'));
      }, 1000);
    }
  }
});

/***/ }),

/***/ "LOYM":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("1GAC"),
  /* template */
  __webpack_require__("Fcz0"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "LeLA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LmUC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/header_info_tv.71388ee.jpg";

/***/ }),

/***/ "N1MC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ time: 1764842394982 });

/***/ }),

/***/ "NAjs":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("uToA")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("2LNQ"),
  /* template */
  __webpack_require__("fZuJ"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a89a849",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "NRev":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("fMio")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("BgJU"),
  /* template */
  __webpack_require__("xe0A"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-85de46a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "P2kB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_md5_js__ = __webpack_require__("Ch3V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_fetch__ = __webpack_require__("yR7j");







var urls = {

  history: function history(type) {
    var url = 'activityCenter/act_list.json';
    return getUrl(url);
  },
  list: '',
  result: function result(id, type) {
    var url = 'activityCenter/act_' + id + '_' + (type || 'eia') + '_result.json';
    return getUrl(url);
  },

  current: function current(id, type) {
    var url = 'activityCenter/act_' + id + '_' + (type || 'eia') + '_info.json';
    return getUrl(url);
  },
  vote: function vote(type) {
    if (type == 'eia') {
      return '//cdn.jin10.com/dc/reports/dc_eia_crude_oil_all.js?v=' + new Date().getTime();
    }

    return '//cdn.jin10.com/dc/reports/dc_nonfarm_payrolls_all.js?v=1520846001?v=' + new Date().getTime();
  },
  wechatCode: function wechatCode(id) {
    return 'https://eia-api.jin10.com/getMyCode/' + id;
  }
};

var __domain = '//jingcai.jin10.com/';

var __apiDomain = 'https://eia-api.jin10.com/';

var getJSONPCallback = function getJSONPCallback(url) {
  var callbackName = 'JQ_' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_md5_js__["a" /* default */])(url.replace(__domain, ''), false, false);
  return callbackName;
};

var getUrl = function getUrl(path) {
  return __domain + path;
};
var getAjaxData = function getAjaxData(url, params, onsuccess, jsonpCallback) {
  window[jsonpCallback] = function (reponse) {

    if (onsuccess) {
      onsuccess(reponse);
    }
  };

  var datas = [];
  if (params && (typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(params)) === 'object') {
    for (var key in params) {
      datas.push(key + '=' + params[key]);
    }
    datas = datas.join('&');
  }

  var __url = url + '?' + datas;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["b" /* addScript */])(__url, function () {});
};

var getJSON = function getJSON(url, params, key, onsuccess, onfail) {
  getAjaxData(url, params, onsuccess, key, onfail);
};
var getData = function getData(url, params, onsuccess, onfail) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])('get', params, url, onsuccess, onfail);
};
var postData = function postData(url, params, onsuccess, onfail) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])('post', params, url, onsuccess, onfail);
};

var state = {
  histories: [],
  org: {},
  historyPage: 1,
  historyState: 'more',
  list: [],
  listState: 'more',
  current: {},
  result: [],
  voteList: [],
  voteType: '',
  myVote: '',
  activityDataType: '',
  activityType: '',
  pageTitle: '',
  wechatCode: {}
};

var getActivityType = function getActivityType() {
  var __type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["c" /* getQueryString */])('type');
  return window.location.href.indexOf('feinong') > -1 || __type == 'feinong' ? 'fn' : 'eia';
};

var getters = {
  histories: function histories(state) {
    return state.histories;
  },
  list: function list(state) {
    return state.list;
  },
  listState: function listState(state) {
    return state.listState;
  },
  result: function result(state) {
    return state.result;
  },
  activityType: function activityType(state) {
    return state.activityType;
  },
  activityDataType: function activityDataType(state) {
    return state.activityDataType;
  },
  guess: function guess(state) {
    return state.current;
  },
  voteList: function voteList(state) {
    return state.voteList;
  },
  voteType: function voteType(state) {
    return state.voteType;
  },
  myVote: function myVote(state) {
    return state.myVote;
  },
  pageTitle: function pageTitle(state) {
    return state.pageTitle;
  },
  wechatCode: function wechatCode(state) {
    return state.wechatCode;
  }

};

var actions = {
  getHistories: function getHistories(_ref, _ref2) {
    var commit = _ref.commit;
    var onCompleted = _ref2.onCompleted,
        currentPage = _ref2.currentPage,
        pageSize = _ref2.pageSize,
        isReload = _ref2.isReload,
        itemId = _ref2.itemId,
        activityType = _ref2.activityType,
        onFilter = _ref2.onFilter;

    if (isReload) {
      state.histories.length = 0;
      state.historyState = 'more';
      state.historyPage = 1;
    } else {
      commit('getHistories', {
        data: state.org.history,
        onCompleted: onCompleted,
        onFilter: onFilter
      });
    }

    var url = urls.history(activityType);

    getJSON(url, {
      v: new Date().getTime()
    }, getJSONPCallback(url), function (data) {
      state.org.history = data;

      commit('getHistories', {
        data: state.org.history,
        onCompleted: onCompleted,
        itemId: itemId,
        activityType: activityType,
        onFilter: onFilter
      });
    });
  },
  getResult: function getResult(_ref3, _ref4) {
    var commit = _ref3.commit;
    var id = _ref4.id,
        onCompleted = _ref4.onCompleted,
        type = _ref4.type;

    state.result.length = 0;
    var url = urls.result(id, type);

    getJSON(url, {
      v: new Date().getTime()
    }, getJSONPCallback(url), function (data) {
      commit('getResult', {
        data: data,
        onCompleted: onCompleted
      });
    }, function (error) {});
  },
  getWechatCode: function getWechatCode(_ref5, _ref6) {
    var commit = _ref5.commit;
    var id = _ref6.id,
        onCompleted = _ref6.onCompleted;

    var url = urls.wechatCode(id) + '?=' + new Date().getTime();

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])({
        type: 'get',
        params: {},
        url: url,
        success: function success(response) {
          if (onCompleted) {
            onCompleted(response);
          }
          resolve(response);
        },
        fail: function fail(response) {
          reject(response);
        }
      });
    });
  },
  getList: function getList(_ref7, _ref8) {
    var commit = _ref7.commit;
    var id = _ref8.id,
        onCompleted = _ref8.onCompleted,
        currentPage = _ref8.currentPage,
        pageSize = _ref8.pageSize,
        isReload = _ref8.isReload;

    if (isReload) {}

    commit('getList', {
      data: state.list,
      onCompleted: onCompleted
    });
    return;

    getJSON(urls.list, {}, function (data) {
      var list = [];
      data.map(function (item) {
        var key = item[1];
        var avatar = '//cdn.jin10.com/avatar/' + key.substr(0, 2) + '/' + key + '/avatar.jpg';

        var _item = {
          nick: item[0],
          avatar: avatar,
          guess_value: item[1]
        };

        list.push(_item);
      });

      commit('getList', {
        data: list,
        onCompleted: onCompleted
      });
    }, function (error) {});
  },
  getData: function getData(_ref9, _ref10) {
    var commit = _ref9.commit;
    var id = _ref10.id,
        onCompleted = _ref10.onCompleted,
        type = _ref10.type,
        isPublish = _ref10.isPublish;

    var url = urls.current(id, type);

    getJSON(url, {
      v: isPublish ? id : new Date().getTime()
    }, getJSONPCallback(url), function (data) {
      commit('getData', {
        data: data,
        onCompleted: onCompleted
      });
    });
  },
  getVote: function getVote(_ref11, _ref12) {
    var commit = _ref11.commit;
    var id = _ref12.id,
        onCompleted = _ref12.onCompleted,
        type = _ref12.type;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["b" /* addScript */])(urls.vote(type), function () {

      var data = (window.dataCenter_data || {})['list'] || {};

      var type = (window.dataCenter_data || {
        types: []
      })['types'][0] || '';
      commit('getVote', {
        data: data,
        onCompleted: onCompleted,
        type: type
      });
    });
  },
  submit: function submit(_ref13, _ref14) {
    var commit = _ref13.commit;
    var id = _ref14.id,
        onCompleted = _ref14.onCompleted,
        value = _ref14.value,
        type = _ref14.type;

    var url = __apiDomain + 'activity/join2/' + id;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_fetch__["a" /* fetch */])({
        type: 'post',
        params: {
          type: type,
          value: value
        },
        url: url,
        success: function success(response) {
          if (onCompleted) {
            onCompleted(response);
          }
          resolve(response);
        },
        fail: function fail(response) {
          reject(response);
        }
      });
    });
  }
};

var mutations = {
  getHistories: function getHistories(state, _ref15) {
    var data = _ref15.data,
        onCompleted = _ref15.onCompleted,
        itemId = _ref15.itemId,
        activityType = _ref15.activityType,
        onFilter = _ref15.onFilter;


    var firstItem;
    var _filter = function _filter(item) {
      return typeof onFilter === 'undefined' ? true : onFilter(item);
    };
    if (itemId) {
      var firstItems = state.org.history.filter(function (item) {
        return item.id == itemId && _filter(item);
      });
      state.histories = state.org.history.filter(function (item) {
        return item.type == firstItems[0].type && _filter(item);
      });
      firstItem = firstItems[0];
    } else if (activityType) {
      state.histories = state.org.history.filter(function (item) {
        return item.type == activityType && _filter(item);
      });

      firstItem = state.histories[0];
    } else {
      var firstItem = state.org.history[0];
      state.histories = state.org.history.filter(function (item) {
        return item.type == firstItem.type && _filter(item);
      });
    }

    if (onCompleted) {
      onCompleted(firstItem);
    }
  },
  setDataType: function setDataType(state, options) {
    state.activityDataType = options.type;
    state.activityType = state.activityDataType == 'eia' ? 'eia' : 'fn';
    state.pageTitle = state.activityDataType == 'eia' ? '金十EIA - 金十数据' : '金十数据 -非农竞猜';
  },
  setMyVote: function setMyVote(state, options) {
    state.myVote = options.value;
  },
  getMyVote: function getMyVote(state, options) {
    if (!options.userId || !options.guessList) {
      return;
    }
    var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__commons_md5_js__["a" /* default */])(options.userId + 'Jin十');
    var value = '';

    (options.guessList || []).map(function (item) {
      var _key = item[1];
      if (key == _key) {
        value = item[2];
      }
    });

    if (value != '') {
      state.myVote = value;
    }

    return value;
  },
  getResult: function getResult(state, _ref16) {
    var data = _ref16.data,
        onCompleted = _ref16.onCompleted;

    state.result = data;
    if (onCompleted) {
      onCompleted(data);
    }
  },
  getWechatCode: function getWechatCode(state, _ref17) {
    var data = _ref17.data,
        onCompleted = _ref17.onCompleted;

    state.wechatCode = data;
    if (onCompleted) {
      onCompleted(data);
    }
  },
  getList: function getList(state, _ref18) {
    var data = _ref18.data,
        onCompleted = _ref18.onCompleted;

    state.list = state.list.concat(data);
    if (onCompleted) {
      onCompleted(data);
    }
  },
  getData: function getData(state, _ref19) {
    var data = _ref19.data,
        onCompleted = _ref19.onCompleted;


    state.current = data;
    if (onCompleted) {
      onCompleted(data);
    }
  },
  getVote: function getVote(state, _ref20) {
    var data = _ref20.data,
        onCompleted = _ref20.onCompleted,
        type = _ref20.type;

    state.voteList = data;
    state.voteType = type;

    if (onCompleted) {
      onCompleted(data);
    }
  },
  submit: function submit(state, _ref21) {
    var data = _ref21.data,
        onCompleted = _ref21.onCompleted;

    if (onCompleted) {
      onCompleted(data);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "QwkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Content__ = __webpack_require__("CeuU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrevueList__ = __webpack_require__("Y2sG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrevueList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PrevueList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VipHeader__ = __webpack_require__("NRev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VipHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__VipHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VipInnerHeader__ = __webpack_require__("mrkT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VipInnerHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__VipInnerHeader__);





var isInner = window.location.href.indexOf('inner') > -1;
var components = {
  TvContent: __WEBPACK_IMPORTED_MODULE_1__Content__["a" /* default */],
  PrevueList: __WEBPACK_IMPORTED_MODULE_2__PrevueList___default.a,
  VipHeader: isInner ? __WEBPACK_IMPORTED_MODULE_4__VipInnerHeader___default.a : __WEBPACK_IMPORTED_MODULE_3__VipHeader___default.a
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (key) {
    Vue.component(key, components[key]);
  });
}

/***/ }),

/***/ "ROKJ":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Gi4D"),
  /* template */
  __webpack_require__("Wpil"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "RbSC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "STAE":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9JkP"),
  /* template */
  __webpack_require__("hSG4"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Ssb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDingMemberInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRemoteDingShowConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var qhDingInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://6bba0123257d411e8fc8bbd0b879c946.z3c.jin10.com',
  headers: {
    'x-app-id': 'dMiaEXHX7OKpTAsX',
    'x-version': '1.0'
  },
  withCredentials: true
});

var getDingMemberInfo = function getDingMemberInfo(params) {
  return qhDingInstance.post('/member/status_bulk', params);
};

var configInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: '//common-open-api.jin10.com',
  headers: {
    'x-app-id': 'zP6WFH7WKz2vrw4Q',
    'x-version': '1.0.0'
  },
  withCredentials: true
});

var getRemoteDingShowConfig = function getRemoteDingShowConfig() {
  return configInstance.get('/configuration/getById', {
    params: {
      id: 1495
    }
  });
};

/***/ }),

/***/ "Uie7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons__ = __webpack_require__("N4+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VipDialog__ = __webpack_require__("rRu1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VipDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__VipDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__video_mixin__ = __webpack_require__("zN7k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commons_dom__ = __webpack_require__("LtSj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_LiveStausTag__ = __webpack_require__("gnYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_LiveStausTag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_LiveStausTag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commons_constants__ = __webpack_require__("kzx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_videojs_quality_switch_button__ = __webpack_require__("itUa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ReloadButton_index__ = __webpack_require__("+C59");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Icon_PlusSvg_vue__ = __webpack_require__("f/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Icon_PlusSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Icon_PlusSvg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Icon_WeiboSvg_vue__ = __webpack_require__("1LXM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Icon_WeiboSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Icon_WeiboSvg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Icon_WeixinSvg_vue__ = __webpack_require__("WUhc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Icon_WeixinSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Icon_WeixinSvg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Icon_QqSvg_vue__ = __webpack_require__("RiHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Icon_QqSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Icon_QqSvg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Icon_ShareSvg_vue__ = __webpack_require__("1kIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Icon_ShareSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Icon_ShareSvg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Icon_WeiboSlimSvg_vue__ = __webpack_require__("nNHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Icon_WeiboSlimSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Icon_WeiboSlimSvg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Icon_WeixinSlimSvg_vue__ = __webpack_require__("KehS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Icon_WeixinSlimSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Icon_WeixinSlimSvg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_WexinShareQrcode_vue__ = __webpack_require__("id5Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_WexinShareQrcode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_WexinShareQrcode_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mixins_bindGlassEffectMixin__ = __webpack_require__("D3kI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Icon_PhoneSvg_vue__ = __webpack_require__("UFBN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Icon_PhoneSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Icon_PhoneSvg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Icon_PlayLineSvg_vue__ = __webpack_require__("hgMY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Icon_PlayLineSvg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Icon_PlayLineSvg_vue__);

































/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  mixins: [__WEBPACK_IMPORTED_MODULE_11__video_mixin__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__mixins_bindGlassEffectMixin__["a" /* default */])({ multiple: true })],
  components: {
    VipDialog: __WEBPACK_IMPORTED_MODULE_10__VipDialog___default.a,
    LiveStausTag: __WEBPACK_IMPORTED_MODULE_13__components_LiveStausTag___default.a,
    PlusSvg: __WEBPACK_IMPORTED_MODULE_18__components_Icon_PlusSvg_vue___default.a,
    WeiboSvg: __WEBPACK_IMPORTED_MODULE_19__components_Icon_WeiboSvg_vue___default.a,
    WeixinSvg: __WEBPACK_IMPORTED_MODULE_20__components_Icon_WeixinSvg_vue___default.a,
    QqSvg: __WEBPACK_IMPORTED_MODULE_21__components_Icon_QqSvg_vue___default.a,
    ShareSvg: __WEBPACK_IMPORTED_MODULE_22__components_Icon_ShareSvg_vue___default.a,
    WeiboSlimSvg: __WEBPACK_IMPORTED_MODULE_23__components_Icon_WeiboSlimSvg_vue___default.a,
    WeixinSlimSvg: __WEBPACK_IMPORTED_MODULE_24__components_Icon_WeixinSlimSvg_vue___default.a,
    WexinShareQrcode: __WEBPACK_IMPORTED_MODULE_25__components_WexinShareQrcode_vue___default.a,
    PhoneSvg: __WEBPACK_IMPORTED_MODULE_27__components_Icon_PhoneSvg_vue___default.a,
    PlayLineSvg: __WEBPACK_IMPORTED_MODULE_28__components_Icon_PlayLineSvg_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['options', 'liveInfo', 'liveUrl', 'liveType', 'isLive', 'isMobile', 'serverTime', 'posterUrl', 'emcee', 'videoID', 'user', 'isLogin']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])(['pageType', 'isEliteVip', 'isVip', 'isBlackGoldVip', 'isYearVip', 'isSuperVip', 'hasGetUser', 'serviceQRCodeConfig', 'topNavs', 'chatRooms', 'hasGetOptions']), {
    poster: {
      get: function get() {
        return this.posterUrl;
      },
      set: function set(v) {
        this.$store.dispatch('setPosterUrl', v);
      }
    },
    title: function title() {
      return this.$route.meta && this.$route.meta.subTitle || this.liveInfo && this.liveInfo.title || this.liveInfo && this.liveInfo.customTitle;
    },
    wechatUrl: function wechatUrl() {
      return this.wechatQRCode;
    },
    wechatQRCode: function wechatQRCode() {
      var serviceQRCodeConfig = this.serviceQRCodeConfig,
          emcee = this.emcee,
          liveType = this.liveType;

      var getConfig = function getConfig(key) {
        var config = serviceQRCodeConfig.find(function (it) {
          return it.key === key;
        });
        return config;
      };
      var data = emcee ? getConfig(emcee) : getConfig(liveType);
      return data && data.qrcode && data.qrcode.length ? data.qrcode[0] : '';
    },
    isTradingPageAndNotAVip: function isTradingPageAndNotAVip() {
      return !this.isVip && this.pageType === 'tradingNew' && !this.options.tradingVideoFree;
    },
    isTradingLiveAndNotVip: function isTradingLiveAndNotVip() {
      return !this.isVip && this.liveType === 'tradingNew' && !this.options.tradingVideoFree;
    },
    isUseM3u8: function isUseM3u8() {
      return this.isMobile || __WEBPACK_IMPORTED_MODULE_9__commons__["c" /* device */].isIpad;
    },
    isTradingPage: function isTradingPage() {
      return this.pageType === 'tradingNew';
    },
    showRoomOnlineCount: function showRoomOnlineCount() {
      return (this.pageType === 'live-d80' || this.liveType === 'live-d80') && [2334976, 7194486].includes(this.user.id);
    },
    currentRoomOnlineCount: function currentRoomOnlineCount() {
      if (this.chatRooms && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.chatRooms).length) {
        var liveD80 = this.chatRooms[36];
        if (liveD80) {
          return liveD80.count;
        }
      }
      return 0;
    }
  }),
  data: function data() {
    return {
      LIVE_ROLE_TYPE: __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */],
      tv: null,
      isLoading: false,
      isShowNextTV: false,
      isCloseNextTV: false,
      nowDatas: {},
      nowData: {},
      monitorID: '',
      timeRange: 30 * 60 * 1000,
      repeatUrl: '',
      repeatImageUrl: '',
      player: null,
      customTitle: '',
      waitingTimer: null,
      curUrl: '',
      showVipDialog: false,
      follow: false,

      hasPreviewVideo: false,
      isPlayingRepeat: false,
      isPlayingRepeatVideo: false,
      isTrySee: false,
      liveRoleType: 0,
      liveId: 0,
      trySeeTimer: null,
      isTrySeeEnd: false,
      repeatTrySeeMax: 5 * 60,
      isRepeatTrySee: false,
      repeatRoleType: 0,
      isRepeatTrySeeEnd: false,
      isRepeat: false,
      trySeeRemain: 0,

      qualityList: [],
      activeQuality: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_14__commons_constants__["a" /* StorageKey */].LIVE_QUAILITY),

      isFullscreen: false
    };
  },

  watch: {
    $route: function $route(to, from) {
      console.log('route--->', to);
      this.refreshLiveInfo(to);
    },
    customTitle: function customTitle() {
      document.title = this.customTitle || this.title;
    },
    liveUrl: function liveUrl(v) {
      var _this = this;

      if (v) {
        if (this.isLive) {
          this.repeatUrl = '';
          this.repeatImageUrl = '';
          this.$nextTick(function () {
            _this.loadVideo(v);
          });
        } else {
          this.repeatUrl = v;
          console.log('setRepeatImageUrl ---');
          this.setRepeatImageUrl(this.options[this.liveType].repeatImage);
        }
      } else {
        this.repeatUrl = '';
        this.repeatImageUrl = '';
        this.disposePlayer();
        this.clearWaitingTimer();
      }
    },
    monitorID: function monitorID(v, oldVal) {
      if (v) {}
    },
    serverTime: function serverTime(v) {
      this.showNextTVTips(v);
    },
    repeatUrl: function repeatUrl(url) {
      console.log('repeatUrl change', url);
    },

    hasGetUser: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.init();
          if (this.isTradingPageAndNotAVip) {
            this.showVipDialog = true;
          }
        }
      }
    }
  },

  created: function created() {
    var _this2 = this;

    this.$bus.$on(__WEBPACK_IMPORTED_MODULE_14__commons_constants__["b" /* BusEvent */].REFRESH_LIVE_INFO, function () {
      console.log('REFRESH_LIVE_INFO');
      _this2.refreshLiveInfo();
    });
  },

  methods: {
    init: function init() {
      var _this3 = this;

      var tradeCollegeType = this.options.conflictProgram;
      this.$nextTick(function () {
        _this3.customTitle = '';
        var routerType = _this3.$route.meta.type || _this3.options.defaultType;
        _this3.getLiveShow(routerType).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(datas) {
            var allDataTypes, nowData, i, l, type, url, isLive, poster, offline, repeat, prevue, emcee, videoID, tradingVideoID;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    allDataTypes = ['live', 'prevue', 'repeat'];
                    nowData = null;
                    i = 0, l = allDataTypes.length;

                  case 3:
                    if (!(i < l)) {
                      _context.next = 10;
                      break;
                    }

                    nowData = datas[allDataTypes[i]];

                    if (!__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(nowData).length) {
                      _context.next = 7;
                      break;
                    }

                    return _context.abrupt('break', 10);

                  case 7:
                    i++;
                    _context.next = 3;
                    break;

                  case 10:

                    _this3.qualityList = nowData.url_tmpl || [];
                    if (_this3.qualityList.length) {
                      _this3.activeQuality = _this3.activeQuality || _this3.qualityList[0].name;
                    }
                    type = nowData.type;
                    url = _this3.getCurrentQualityUrl();


                    window._videoType = (type === tradeCollegeType ? '' : type) || _this3.options[routerType].roomID;
                    isLive = !!datas.live.url;
                    poster = '';
                    offline = datas.offline;
                    repeat = datas.repeat;
                    prevue = datas.prevue;
                    emcee = nowData.emcee;
                    videoID = nowData.id;
                    tradingVideoID = videoID;

                    _this3.monitorID = nowData.monitor_id;
                    console.log('isLive', isLive);
                    if (isLive) {
                      console.log('now data', nowData);
                      url = _this3.getCurrentQualityUrl();

                      _this3.setCustomTitle(datas.live);
                      _this3.liveId = nowData.id;
                      _this3.repeatImageUrl = '';
                      _this3.poster = _this3.isTradingPageAndNotAVip ? _this3.options.tradingNew.notVipImg || _this3.options.tradingNew.notVipImage : nowData.thumb;
                    } else {
                      if (_this3.compareTheTime(_this3.serverTime || new Date().getTime(), offline.live_end_time) && !offline.repeat_url) {
                        console.log('获取直播结束的时间，如果和当前时间相差30分钟，则显示回放图片');
                        _this3.repeatImageUrl = '';
                        type = offline.type || routerType;
                        url = '';
                        emcee = offline.emcee;
                        console.log('type---> ', type);
                        poster = offline.thumb || _this3.options[type].overImg;
                        tradingVideoID = offline.id;
                        _this3.setCustomTitle(offline);
                      } else {
                        if (prevue.id) {
                          tradingVideoID = prevue.id;
                        } else {
                          tradingVideoID = repeat.id;
                        }

                        if (!_this3.compareTheTime(prevue.date, null, 8 * 60 * 60 * 1000)) {
                          console.log('如果不是直播，且预告和当前时间是在8小时外，也就是重播');
                          _this3.isRepeat = true;
                          type = repeat.type || routerType;
                          emcee = repeat.emcee;
                          url = repeat.repeat_url;
                          videoID = repeat.id;
                          _this3.repeatRoleType = repeat.is_vip;
                          if (_this3.getIsTrySeeType(repeat.is_vip)) {
                            _this3.isRepeatTrySee = true;
                            _this3.repeatTrySeeMax = repeat.try_see * 60;
                          }
                          _this3.repeatUrl = url;
                          _this3.setRepeatImageUrl(_this3.options[type].repeatImage);
                          _this3.setCustomTitle(repeat);
                        } else {
                          console.log('预告');
                          emcee = prevue.emcee;
                          url = '';
                          _this3.repeatImageUrl = '';
                          if (type === 'tradingNew' && _this3.isVip || type !== 'tradingNew') {
                            if (prevue.video_preview) {
                              _this3.hasPreviewVideo = true;
                              _this3.$nextTick(function () {
                                _this3.loadVideo(prevue.video_preview);
                              });
                            }
                            poster = prevue.pre_cover || prevue.thumb;
                          }
                          _this3.setCustomTitle(prevue);
                        }
                      }
                    }

                    _this3.$store.dispatch('setLiveState', isLive);
                    _this3.$store.dispatch('setLiveType', type);
                    _this3.$store.dispatch('setEmcee', emcee);
                    _this3.$store.dispatch('setVideoID', videoID);
                    _this3.$store.dispatch('setTradingVideoID', tradingVideoID);
                    _this3.$store.dispatch('setChatReadyState', true);
                    _this3.$store.dispatch('setPrevueTime', datas.prevue.date);

                    _this3.getAttendCheck();

                    _this3.resizeSide();

                    if (isLive) {
                      _this3.liveRoleType = nowData.is_vip;
                      if (_this3.getIsTrySeeType(nowData.is_vip)) {
                        _this3.isTrySee = true;

                        _this3.trySeeRemain = nowData.try_see * 60 * 1000;
                      }
                    }

                    if (url) {
                      _context.next = 39;
                      break;
                    }

                    _this3.poster = poster || _this3.liveInfo.previewImg;
                    return _context.abrupt('return', false);

                  case 39:
                    _this3.$store.dispatch('setLiveUrl', url);

                  case 40:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this3);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    },
    refreshLiveInfo: function refreshLiveInfo(to) {
      this.hasPreviewVideo = false;
      this.isPlayingRepeat = false;
      this.isTrySee = false;
      this.isTrySeeEnd = false;
      this.isRepeatTrySee = false;
      this.isRepeatTrySeeEnd = false;
      this.isFullscreen = false;
      this.isRepeat = false;
      clearTimeout(this.trySeeTimer);
      this.poster = '';
      if (this.liveUrl) {
        this.$store.dispatch('setLiveUrl', false);
      }
      if (to && to.meta.type === 'tradingNew' && !this.isVip && !this.options.tradingVideoFree && this.hasGetOptions) {
        this.showVipDialog = true;
      }
      this.init();
    },
    filterData: function filterData(res) {
      var tradeCollegeType = this.options.conflictProgram;
      var type = this.$route.meta.type || 'tv';

      var rebuildRes = {};

      var allDataTypes = ['live', 'prevue', 'repeat', 'offline'];
      allDataTypes.map(function (el) {
        rebuildRes[el] = { repeatImage: '' };
      });
      for (var key in res) {
        var item = res[key];
        if (item && typeof item['type'] !== 'undefined') {
          if (item['type'] !== tradeCollegeType) {
            rebuildRes[key] = item;
          }
        } else {
          rebuildRes[key] = item;
        }
      }

      return res;
    },
    setCustomTitle: function setCustomTitle(info) {
      if (info && (info.title || info.room_name)) {
        this.customTitle = info.title || info.room_name;
      }
    },
    compareTheTime: function compareTheTime(endTime, startTime) {
      var timeRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.timeRange;

      startTime = startTime || this.serverTime;
      startTime = this.timeTrans(startTime);
      endTime = this.timeTrans(endTime);
      var nowTime = startTime || new Date().getTime();
      var diffTime = endTime - nowTime;

      if (diffTime > 0 && diffTime <= timeRange) {
        return true;
      }
      return false;
    },
    timeTrans: function timeTrans(time) {
      if (typeof time === 'number') {
        time = time.toString().length < 13 ? time * 1000 : time;
      } else if (typeof time === 'string') {
        time = time.replace(/-/g, '/');
      }
      return new Date(time).getTime();
    },
    loadVideo: function loadVideo(url) {
      if (url.indexOf('https://') === -1) {
        url = url.replace('http:', 'https:');
      }

      console.log('living url:', url);
      this.curUrl = url;

      this.playVideo();
      if (this.isLive) {
        this.statistics();
      }
      this.closeNextTV();
    },
    disposePlayer: function disposePlayer() {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    },
    playVideo: function playVideo() {
      var _this4 = this;

      var tv = null;
      if (this.isMobile) {
        tv = document.querySelector('#J_tv_video');
        tv.src = this.curUrl;

        tv.addEventListener('play', function () {
          _this4.report();
        });

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__commons_dom__["a" /* on */])(tv, 'pause', function () {
          console.log('暂停: paused', tv.paused);
          _this4.stopLiveVideoTimer();
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__commons_dom__["a" /* on */])(tv, 'ended', function () {
          _this4.stopLiveVideoTimer();
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__commons_dom__["a" /* on */])(tv, 'enterpictureinpicture', function () {
          console.log('进入画中画模式');
          if (_this4.jsBridge.isApp) {
            _this4.jsBridge.dispatch('webClickPIPBtn');
          }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__commons_dom__["a" /* on */])(tv, 'timeupdate', function () {
          if (_this4.isRepeatTrySee && tv.currentTime > _this4.repeatTrySeeMax) {
            try {
              tv.currentTime = _this4.repeatTrySeeMax;
              tv.pause();
              _this4.isRepeatTrySeeEnd = true;
            } catch (error) {
              console.error(error);
            }
          }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__commons_dom__["a" /* on */])(tv, 'leavepictureinpicture', function (e) {
          console.log('退出画中画模式');
          console.log('播放中', !tv.paused);
          if (_this4.jsBridge.isApp) {
            _this4.jsBridge.dispatch('h5PIPBtnAction', tv.paused ? '0' : '1');
          }
        });

        return false;
      }
      this.disposePlayer();
      var options = {
        mediaType: 'video',
        forceLive: this.isLive,
        sources: [this.curUrl],
        fluid: true,
        poster: this.posterUrl,

        controls: true,
        autoplay: true,
        playsinline: true,
        controlBar: {
          remainingTimeDisplay: true
        }
      };
      if (!this.isLive) {
        options.playbackRates = [1, 1.5, 1.75, 2];
      }

      this.player = Jin10Player('#J_tv_box', options, function () {
        if (!_this4.isRepeat) {
          _this4.player.qualityMenu = new __WEBPACK_IMPORTED_MODULE_15__plugins_videojs_quality_switch_button__["a" /* default */](_this4.player, {
            label: _this4.activeQuality,
            onChange: function onChange(name) {
              localStorage.setItem(__WEBPACK_IMPORTED_MODULE_14__commons_constants__["a" /* StorageKey */].LIVE_QUAILITY, name);
              var qualityItem = _this4.qualityList.find(function (it) {
                return it.name === name;
              });
              if (qualityItem) {
                console.log('qualityItem.url', qualityItem.url);
                _this4.player.src(qualityItem.url);
              }
            }
          });
        }
        if (_this4.isTrySee || _this4.isRepeatTrySee) {
          if (_this4.isRepeatTrySee) {
            _this4.liveRoleType = _this4.nowDatas.repeat.is_vip;
          } else {
            _this4.liveRoleType = _this4.nowDatas.live.is_vip;
          }
          var logoOptions = {
            image: _this4.liveRoleType === __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].svip ? 'https://tv.jin10.com/assets/img/open_elite_vip.png?v=2' : 'https://tv.jin10.com/assets/img/open_vip.png?v=2',
            url: _this4.liveRoleType === __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].svip ? 'https://www.jin10.com/vip/payment/index.html#/?tab=elite' : 'https://www.jin10.com/vip/payment/index.html',
            position: 'top-right',
            fadeDelay: null,
            width: 270,
            padding: 10
          };
          var tryReadOption = {
            btnLink: _this4.liveRoleType === __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].svip ? 'https://www.jin10.com/vip/payment/index.html#/?tab=elite' : 'https://www.jin10.com/vip/payment/index.html',
            btnColor: _this4.liveRoleType === __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].svip ? '#EB4B43' : '#E4CE97',
            btnImage: _this4.liveRoleType === __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].svip ? 'https://cdn.jin10.com/assets/img/sites/video/elite_vip/vip_buy.png' : 'https://cdn.jin10.com/assets/img/sites/video/vip/vip_buy.png',
            fontSize: 14,
            btnImageWidth: 30,
            padding: '4px 10px',
            bottom: 40,
            left: 10,
            autoMinify: false
          };
          _this4.player.logo(logoOptions);

          _this4.player.tryread(tryReadOption);
        }
        _this4.clearWaitingTimer();
      });

      this.playerEvents();
    },
    playerEvents: function playerEvents() {
      var _this5 = this;

      window.player = this.player;
      this.player.on('play', function () {
        console.log('play');
        if (_this5.isTrySee) {
          _this5.checkTrySeeLoop();
        }
        _this5.clearWaitingTimer();

        _this5.report();
      });
      this.player.on('pause', function () {
        console.log('pause');
        _this5.stopLiveVideoTimer();
      });
      this.player.on('ended', function () {
        console.log('ended');
        _this5.stopLiveVideoTimer();
        _this5.errorReplay();
        if (_this5.hasPreviewVideo) {
          _this5.previewLoop();
        }
      });
      this.player.on('waiting', function () {
        console.log('waiting');
        _this5.errorReplay(15000);
      });
      this.player.on('ready', function () {
        console.log('ready');
      });
      this.player.on('enterpictureinpicture', function () {
        console.log('画中画模式');
        _this5.jsBridge.dispatch('webClickPIPBtn');
      });
      this.player.on('timeupdate', function () {
        if (_this5.isRepeatTrySee && _this5.player.currentTime() > _this5.repeatTrySeeMax) {
          try {
            _this5.player.currentTime(_this5.repeatTrySeeMax);
            _this5.player.pause();
            _this5.player.exitFullscreen();
            _this5.isRepeatTrySeeEnd = true;
          } catch (error) {
            console.error(error);
          }
        }
      });
      this.player.on('fullscreenchange', function () {
        _this5.isFullscreen = !_this5.isFullscreen;
      });
      this.player.on('webkitfullscreenchange', function () {
        _this5.isFullscreen = !_this5.isFullscreen;
      });
      this.player.on('error', function (e) {
        try {
          var MEDIA_ERR_SRC_NOT_SUPPORTED = 4;

          var MEDIA_ERR_DECODE = 3;

          console.error('[PLAY ERROR]:', _this5.player.error());
          var errorData = _this5.player.error();
          if ([MEDIA_ERR_SRC_NOT_SUPPORTED, MEDIA_ERR_DECODE].includes(errorData.code)) {
            var _MEDIA_ERR_SRC_NOT_SU;

            var errorText = (_MEDIA_ERR_SRC_NOT_SU = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_MEDIA_ERR_SRC_NOT_SU, MEDIA_ERR_SRC_NOT_SUPPORTED, '源视频格式错误或推流未开始'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_MEDIA_ERR_SRC_NOT_SU, MEDIA_ERR_DECODE, '网络异常, 解码失败, 需检查推流'), _MEDIA_ERR_SRC_NOT_SU)[errorData.code];
            console.error('[PLAY ERROR]:', errorText);
            setTimeout(function () {
              var reloadBtnInstance = new __WEBPACK_IMPORTED_MODULE_16__components_ReloadButton_index__["a" /* default */]();
              reloadBtnInstance.$mount();
              var wrapper = document.querySelector('.vjs-modal-dialog-content');
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__components_ReloadButton_index__["a" /* default */])(wrapper, {
                onClick: function onClick() {
                  var name = '标清';
                  localStorage.setItem(__WEBPACK_IMPORTED_MODULE_14__commons_constants__["a" /* StorageKey */].LIVE_QUAILITY, name);
                  var qualityItem = _this5.qualityList.find(function (it) {
                    return it.name === name;
                  });
                  if (qualityItem) {
                    _this5.player.src(qualityItem.url);
                  } else {
                    window.location.reload();
                  }
                }
              });
            }, 200);
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
    clearWaitingTimer: function clearWaitingTimer() {
      this.waitingTimer && clearInterval(this.waitingTimer);
    },
    previewLoop: function previewLoop() {
      this.player.play();
    },
    errorReplay: function errorReplay(t) {
      if (!this.isLive) {
        return false;
      }
      this.clearWaitingTimer();
    },
    getLiveShow: function getLiveShow(type) {
      var _this6 = this;

      var params = type ? { type: type } : '';
      if (!__WEBPACK_IMPORTED_MODULE_8__commons_config__["a" /* isProduction */]) {
        params = params ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, params, { test: '/testing/' }) : { test: '/testing/' };
      }
      this.isLoading = true;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this6.isTradingPageAndNotAVip) {
          var data = {
            live: {},
            offline: {},
            prevue: {},
            repeat: {}
          };
          _this6.nowDatas = data;
          _this6.isLoading = false;
          if (_this6.pageType !== 'tradingNew') {
            resolve(data);
            return false;
          }
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__commons_fetch__["a" /* fetch */])({
          type: 'GET',
          url: __WEBPACK_IMPORTED_MODULE_8__commons_config__["e" /* requestAttendUrl */].now,
          params: params,
          headers: __WEBPACK_IMPORTED_MODULE_8__commons_config__["e" /* requestAttendUrl */].headers,
          callback: function callback() {
            _this6.isLoading = false;
          },
          success: function success(res) {
            _this6.nowDatas = _this6.filterData(res);
            resolve(_this6.filterData(res));
          },
          error: function error() {
            _this6.isLoading = false;
            reject();
          }
        });
      });
    },
    onAttend: function onAttend() {
      var _this7 = this;

      var routerType = this.$route.meta.type || this.options.defaultType || window._videoType;
      var params = {
        room: routerType
      };
      var url = this.follow ? __WEBPACK_IMPORTED_MODULE_8__commons_config__["e" /* requestAttendUrl */].cancel : __WEBPACK_IMPORTED_MODULE_8__commons_config__["e" /* requestAttendUrl */].follow;
      if (this.isLogin) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__commons_fetch__["a" /* fetch */])({
          type: 'POST',
          url: url,
          params: params,
          headers: __WEBPACK_IMPORTED_MODULE_8__commons_config__["e" /* requestAttendUrl */].headers,
          success: function success(res) {
            _this7.getAttendCheck();
          }

        });
      } else {
        this.showLogin();
      }
    },
    getAttendCheck: function getAttendCheck() {
      var _this8 = this;

      var routerType = this.$route.meta.type || this.options.defaultType || window._videoType;
      var params = {
        room: routerType
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__commons_fetch__["a" /* fetch */])({
        type: 'GET',
        url: __WEBPACK_IMPORTED_MODULE_8__commons_config__["e" /* requestAttendUrl */].check,
        params: params,
        headers: __WEBPACK_IMPORTED_MODULE_8__commons_config__["e" /* requestAttendUrl */].headers,
        success: function success(res) {
          _this8.follow = res.data.follow;
        }
      });
    },
    onSocketData: function onSocketData(code) {
      var ele = document.createElement('script');
      ele.innerHTML = code;
      document.body.appendChild(ele);
    },
    showRepeat: function showRepeat() {
      var _this9 = this;

      if (!this.repeatUrl) {
        this.$tips({ message: '暂时无回放视频' });
        return false;
      }
      this.repeatImageUrl = '';
      this.$nextTick(function () {
        _this9.loadVideo(_this9.repeatUrl);
        _this9.isPlayingRepeat = true;
        _this9.repeatUrl = '';
      });
    },
    showNextTV: function showNextTV() {
      var data = this.nowDatas.prevue;
      var type = data.type;
      var emcee = (type === 'tv' || type === 'fangtan') && !data.emcee ? 'Becca' : data.emcee;
      this.closeNextTV();
      this.poster = this.options[type].previewImg;
      this.$store.dispatch('setLiveUrl', '');
      this.$store.dispatch('setLiveType', type);
      this.$store.dispatch('setLiveState', false);

      this.$store.dispatch('setEmcee', emcee);
    },
    closeNextTV: function closeNextTV() {
      if (!this.isShowNextTV) {
        return false;
      }
      this.isShowNextTV = false;
      this.isCloseNextTV = true;
    },
    showNextTVTips: function showNextTVTips(serverTime) {
      if (this.posterUrl) {
        this.closeNextTV();
      }
      if (this.isCloseNextTV || this.isShowNextTV || this.posterUrl) {
        return false;
      }
      if (this.compareTheTime(this.nowDatas.prevue.date, serverTime)) {
        this.isShowNextTV = true;
      }
    },
    getEmceeInfo: function getEmceeInfo(key, obj) {
      var url = '';
      var emcee = this.emcee;
      var liveInfo = obj || this.liveInfo || {};
      var data = emcee ? liveInfo[emcee] : liveInfo;
      return data ? data[key] : '';
    },
    statistics: function statistics() {
      var img = new Image();
      img.src = 'https://tv-d.jin10.com/bg.png?t=' + this.videoID;
    },
    __getCurrentItemRepeatImage: function __getCurrentItemRepeatImage() {},
    setRepeatImageUrl: function setRepeatImageUrl(url, info) {
      console.log(this.pageType, this.liveType);
      if (this.isTradingPageAndNotAVip) {
        this.repeatImageUrl = this.options.tradingNew.notVipImg || this.options.tradingNew.notVipImage;
        return false;
      }
      this.repeatImageUrl = url;
    },
    toVipPage: function toVipPage() {
      var _this10 = this;

      var url = this.liveRoleType === __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].svip ? 'https://www.jin10.com/vip_payment/index.html#/?tab=elite' : 'https://www.jin10.com/vip/payment/index.html';
      if (this.jsBridge.isApp) {
        this.jsBridge.dispatch('openAppWebViewWithNav', { url: url });
        return false;
      }


      var columnName = this.pageType && this.topNavs.find(function (it) {
        return it.type === _this10.pageType;
      }) ? this.topNavs.find(function (it) {
        return it.type === _this10.pageType;
      }).name : '金十TV';

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__commons_utils__["e" /* jin10Behavior */])({
        pageName: 'tv直播页',
        module: columnName + '|\u64AD\u653E\u5668',
        action: '点击',
        type: '按钮',
        object: '购买',
        params: {
          live_name: document.title,
          btn_text: '立即成为VIP'
        }
      });
      window.open(url, '_blank');
    },
    resizeSide: function resizeSide() {
      var _this11 = this;

      this.$nextTick(function () {
        setTimeout(function () {
          _this11.$bus.$emit('RESIZE_SIDE');
        }, 400);
      });
    },
    checkTrySeeLoop: function checkTrySeeLoop() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var remain;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                remain = _this12.trySeeRemain;

                if (remain >= 0) {
                  _this12.trySeeRemain -= 1000;

                  clearTimeout(_this12.trySeeTimer);
                  _this12.trySeeTimer = setTimeout(function () {
                    _this12.checkTrySeeLoop();
                  }, 1000);
                } else {
                  _this12.clearWaitingTimer();
                  _this12.player.pause();

                  _this12.isTrySeeEnd = true;
                }

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this12);
      }))();
    },
    getIsTrySeeType: function getIsTrySeeType(videoRoleType) {
      console.log('videoRoleType', videoRoleType);
      console.log('isEliteVip', this.isEliteVip);
      var userLevel = __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].common;
      if (this.isSuperVip || this.isBlackGoldVip || this.isYearVip) {
        userLevel = __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].yearVip;
      } else if (this.isVip) {
        userLevel = __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].vip;
      } else if (this.isEliteVip) {
        userLevel = __WEBPACK_IMPORTED_MODULE_14__commons_constants__["c" /* LIVE_ROLE_TYPE */].svip;
      }
      console.log('userLevel', userLevel);
      if (userLevel < videoRoleType) {
        return true;
      }
      return false;
    },
    getCurrentQualityUrl: function getCurrentQualityUrl() {
      var _this13 = this;

      var find = this.qualityList.find(function (it) {
        return it.name === _this13.activeQuality;
      });

      return find ? find.url : this.qualityList.slice(-1)[0] ? this.qualityList.slice(-1)[0].url : '';
    },
    showLogin: function showLogin() {
      if (this.jsBridge.isApp) {
        this.jsBridge.login();
      } else {
        this.$store.dispatch('showLogin');
      }
    },
    onPopoverShow: function onPopoverShow(refName) {
      var el = this.$refs[refName].popperElm;
      this.bindGlassEffect(el, { type: 'black' }, refName);
    }
  }
});

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogin", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFetchAppUserData", function() { return isFetchAppUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasGetOptions", function() { return hasGetOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "liveType", function() { return liveType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "liveInfo", function() { return liveInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "liveUrl", function() { return liveUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLive", function() { return isLive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "channelLiveState", function() { return channelLiveState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chatReadyState", function() { return chatReadyState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serverTime", function() { return serverTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "posterUrl", function() { return posterUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emcee", function() { return emcee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "videoID", function() { return videoID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tradingVideoID", function() { return tradingVideoID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevueTime", function() { return prevueTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fmLivePlayState", function() { return fmLivePlayState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fmReplayState", function() { return fmReplayState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fmVideo", function() { return fmVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fmEmmecNotice", function() { return fmEmmecNotice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isShowFMSign", function() { return isShowFMSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weekTalkDatas", function() { return weekTalkDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobileView", function() { return isMobileView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var user = function user(state) {
  return state.user;
};

var options = function options(state) {
  return state.options;
};

var isLogin = function isLogin(state) {
  return !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.user || {}).length && !!state.user.nick;
};

var isFetchAppUserData = function isFetchAppUserData(state) {
  return state.isFetchAppUserData;
};

var hasGetOptions = function hasGetOptions(state) {
  return state.hasGetOptions;
};

var liveType = function liveType(state) {
  return state.liveType;
};

var liveInfo = function liveInfo(state) {
  return state.liveInfo;
};

var liveUrl = function liveUrl(state) {
  return state.liveUrl;
};

var isLive = function isLive(state) {
  return state.isLive;
};

var channelLiveState = function channelLiveState(state) {
  return state.channelLiveState;
};

var chatReadyState = function chatReadyState(state) {
  return state.chatReadyState;
};

var isMobile = function isMobile(state) {
  return state.isMobile;
};

var serverTime = function serverTime(state) {
  return state.serverTime;
};

var posterUrl = function posterUrl(state) {
  return state.posterUrl;
};

var emcee = function emcee(state) {
  return state.emcee;
};

var videoID = function videoID(state) {
  return state.videoID;
};

var tradingVideoID = function tradingVideoID(state) {
  return state.tradingVideoID;
};

var prevueTime = function prevueTime(state) {
  return state.prevueTime;
};

var fmLivePlayState = function fmLivePlayState(state) {
  return state.fmLivePlayState;
};

var fmReplayState = function fmReplayState(state) {
  return state.fmReplayState;
};

var fmVideo = function fmVideo(state) {
  return state.fmVideo;
};

var fmEmmecNotice = function fmEmmecNotice(state) {
  return state.fmEmmecNotice;
};

var isShowFMSign = function isShowFMSign(state) {
  return state.isShowFMSign;
};

var weekTalkDatas = function weekTalkDatas(state) {
  return state.weekTalkDatas;
};

var isMobileView = function isMobileView(state) {
  return state.windowWidth < 768;
};

/***/ }),

/***/ "Uq1x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/kexinwangzhan.fcb135b.png";

/***/ }),

/***/ "Wpil":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (false) ? _c('div', {
    staticClass: "jin-list",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "jin-list__wrap"
  }, [_c('div', {
    ref: "box",
    staticClass: "jin-list__box"
  }, [_c('div', {
    staticClass: "jin-list__h"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    ref: "navWrap",
    staticClass: "jin-list-nav"
  }, _vm._l((_vm.list), function(item, key) {
    return _c('li', {
      key: key,
      ref: ("nav-" + key),
      refInFor: true,
      staticClass: "jin-list-nav__item",
      class: {
        'is-active': _vm.type === key
      },
      on: {
        "click": function($event) {
          return _vm.getDatas(key)
        }
      }
    }, [_vm._v(_vm._s(_vm.getNavTitle(key)))])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "jin-list__more",
    attrs: {
      "href": ("https://v.jin10.com/list.html?cate=" + _vm.id),
      "target": "_blank"
    }
  }, [_vm._v("查看更多")])]), _vm._v(" "), _c('div', {
    staticClass: "jin-list__b"
  }, [_c('ul', {
    staticClass: "jin-news"
  }, _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      key: index,
      staticClass: "jin-news__item"
    }, [(data) ? [_c('div', {
      staticClass: "jin-news__h"
    }, [_c('img', {
      attrs: {
        "src": data.thumb,
        "alt": data.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "jin-news-mask"
    }, [_c('div', {
      staticClass: "jin-news-mask__box"
    }, [_c('a', {
      staticClass: "jin-news__btn",
      attrs: {
        "href": ("https://v.jin10.com/details.html?id=" + (data.id)),
        "target": "_blank"
      }
    }, [_c('icon', {
      attrs: {
        "type": "play"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "jin-news__btn"
    }, [_c('icon', {
      attrs: {
        "type": "share"
      }
    }), _vm._v(" "), _c('share-button', {
      attrs: {
        "url": ("https://v.jin10.com/details.html?id=" + (data.id)),
        "title": data.title
      }
    })], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "jin-news__b"
    }, [_c('a', {
      attrs: {
        "href": ("https://v.jin10.com/details.html?id=" + (data.id)),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "jin-news__info"
    }, [_c('span', [_vm._v(_vm._s(data.title_sub))])]), _vm._v(" "), _c('h3', {
      staticClass: "jin-news__title",
      class: {
        'is-none-subtitle': !data.title_sub
      }
    }, [_vm._v(_vm._s(data.title))])])])] : _vm._e()], 2)
  }), 0)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "jin-list__title"
  }, [_c('span', [_vm._v("相关推荐")])])
}]}

/***/ }),

/***/ "Y2sG":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("5OR9"),
  /* template */
  __webpack_require__("7NxD"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "YjHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons__ = __webpack_require__("N4+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apis__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__buildTime__ = __webpack_require__("N1MC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HeaderNew_RoomNav_vue__ = __webpack_require__("MYRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HeaderNew_RoomNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_HeaderNew_RoomNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BaseOverlay_vue__ = __webpack_require__("X0cZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BaseOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_BaseOverlay_vue__);













var privatePageConfig = {
  'gammaPri': 1539,
  'ttps-priv': 1550
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    RoomNav: __WEBPACK_IMPORTED_MODULE_8__components_HeaderNew_RoomNav_vue___default.a,
    BaseOverlay: __WEBPACK_IMPORTED_MODULE_9__components_BaseOverlay_vue___default.a

  },
  data: function data() {
    return {
      password: '',
      passwordPopup: false,
      showContent: true,
      isOverlayVisible: false,
      jumpItem: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isLogin', 'isMobile', 'liveType', 'isMobileView']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['pageType', 'user', 'topNavs', 'hasGetUser', 'hasGetDingInfo', 'hasBuyDing']), {
    vipLivePage: function vipLivePage() {
      return ['vip', 'tradingNew'].includes(this.pageType);
    },
    headerUser: function headerUser() {
      if (this.user && this.user.fail) {
        return null;
      }
      return this.user;
    }
  }),
  watch: {
    '$route': {
      immediate: true,
      handler: function handler(to, from) {
        this.$store.dispatch('setPageType', to.meta.type);
        var privatePage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(privatePageConfig);
        if (privatePage.includes(to.meta.type)) {
          this.openPasswordPopup();
          this.showContent = false;
        } else {
          this.showContent = true;
          this.passwordPopup = false;
        }
      }
    },
    user: {
      handler: function handler(newVal) {
        console.log('user -->', newVal);
      },

      immediate: true
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('checkDevice', __WEBPACK_IMPORTED_MODULE_4__commons__["c" /* device */].isMobile);

    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getOpation').then(function () {
      next();
    });
  },
  created: function created() {
    var _this = this;

    this.localTimeLoop();
    this.$store.dispatch('getServiceQRCode');
    this.$store.dispatch('setPageType', this.$route.meta.type);
    if (this.jsBridge.isNewApp && !this.vipLivePage) {
      this.jsBridge.dispatch('openAppTV');
    }

    if (this.jsBridge.isApp) {
      this.jsBridge.getUserInfo(true).then(function (data) {
        var token = data.token;
        if (token) {
          data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, { t: token });
        }

        __WEBPACK_IMPORTED_MODULE_5__commons_utils__["d" /* cookie */].set('x-token', token, null, '/', '.jin10.com', true);

        _this.$store.dispatch('setUser', data);
        _this.$store.dispatch('setAppUserDataState', true);
      }).catch(function () {
        _this.$store.dispatch('setUser', { fail: true });
      });
    } else {
      this.$store.dispatch('getUser', {}).then(function () {
        _this.$store.dispatch('setAppUserDataState', true);
      }).catch(function () {});
    }

    window.addEventListener('message', function (e) {
      if (Object.prototype.toString.call(e.data) === '[object Object]') {
        if (e.data.event === 'CHAT_LINK_CLICK') {
          var name = _this.user ? _this.user.nick : '';
          var nav = _this.topNavs.find(function (it) {
            return it.type === (_this.liveType || _this.pageType);
          });
          var module = nav ? nav.name : '金十智投';
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__commons_utils__["e" /* jin10Behavior */])({
            pageName: 'tv直播页',
            module: module,
            action: '点击',
            type: '按钮',
            object: '链接',
            params: {
              name: name,
              id: e.data.data.id,
              url: e.data.data.url
            }
          });
        } else if (e.data.type === 'UPDATE_ROOM') {
          _this.handleUpdateRoomData(e.data.data);
        }
      }
    });
  },
  mounted: function mounted() {
    var time = __WEBPACK_IMPORTED_MODULE_7__buildTime__["a" /* default */] ? new Date(__WEBPACK_IMPORTED_MODULE_7__buildTime__["a" /* default */].time) : '';
    console.log('buildTime -->', time);
    if (window.location.href.indexOf('env=test') > -1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__commons_utils__["b" /* addScript */])('https://cdn.jin10.com/assets/js/eruda.js', function () {
        window.eruda.init();
      });
    }
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    updatePrevueShow: function updatePrevueShow(v) {
      this.$refs.header && this.$refs.header.showPrevueList(v);
      this.$refs.header.$refs.navFocus && (this.$refs.header.$refs.navFocus.isShowPrevueList = v);
    },
    localTimeLoop: function localTimeLoop() {
      var _this2 = this;

      this.$store.dispatch('setLocalTime');
      setTimeout(function () {
        _this2.localTimeLoop();
      }, 1000);
    },
    onResize: function onResize() {
      this.$store.dispatch('setWindowWidth', window.innerWidth);
    },
    handleUpdateRoomData: function handleUpdateRoomData(data) {
      this.$store.dispatch('updateRoomInfo', data);
    },
    closePasswordPopup: function closePasswordPopup() {
      this.password = '';
      this.passwordPopup = false;
    },
    checkPassword: function checkPassword() {
      var _this3 = this;

      if (!this.password.trim()) {
        this.$tips('请输入密码');
        return;
      }

      var id = privatePageConfig[this.$route.meta.type];
      if (!id) {
        this.$tips('该页面暂不支持密码访问');
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__apis__["b" /* getConfig */])({ id: id }).then(function (res) {
        var _res$data$data$formDa = res.data.data.formData,
            formData = _res$data$data$formDa === undefined ? {} : _res$data$data$formDa;
        var _formData$pwd = formData.pwd,
            pwd = _formData$pwd === undefined ? '' : _formData$pwd;


        if (pwd !== _this3.password.trim()) {
          _this3.$tips('密码错误');
          return;
        }

        _this3.showContent = true;
        _this3.passwordPopup = false;
      });
    },
    openPasswordPopup: function openPasswordPopup() {
      this.password = '';
      this.passwordPopup = true;
    },
    onUserAction: function onUserAction(action) {
      this.$store.dispatch('showLogin', action);
    },
    onRoomNavLiveTips: function onRoomNavLiveTips(item) {
      this.jumpItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item);
      this.isOverlayVisible = true;
    },
    handleJump: function handleJump() {
      var item = this.jumpItem;
      this.isOverlayVisible = false;
      if (item.router) {
        this.$router.push(item.link);
        return false;
      }
      window.open(item.link, item.target ? item.target : '_blank');
    }
  }
});

/***/ }),

/***/ "b+X2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMAHAgR6BicheyVjVoB0D4dXceUAAAAUUlEQVQY02MgAEoSULj/v6JyP8JYTI8gXNatYK7KXwj3yA8FEFf+P4Sr/9+AhtzoAGQuU78PMpf5/6cB5n6FceP/QwKWy5OBYcoCBjZ3AnEAAFNUdeZdaLn0AAAAAElFTkSuQmCC"

/***/ }),

/***/ "cF0O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






var TRADING_NEW_TITLE = '同声传译仅限会员观看哦';
var TRADING_NEW_CONTENT = '请升级精英/VIP会员解锁直播>>';

var TRADING_NEW_OCT_TITLE = '同声传译直播仅限VIP/精英会员观看';
var TRADING_NEW_OCT_CONTENT = '限时5折成为精英，即可观看>>';

var OCT_ACTIVITY_START_TIME = new Date('2022/10/14 00:00:00').getTime();
var OCT_ACTIVITY_EXPIRE_TIME = new Date('2022/10/24 00:00:00').getTime();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['pageType', 'isVip', 'isEliteVip', 'localTime']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isLogin', 'liveType', 'options']), {
    isOctActivity: function isOctActivity() {
      return this.localTime >= OCT_ACTIVITY_START_TIME && this.localTime < OCT_ACTIVITY_EXPIRE_TIME && this.pageType === 'tradingNew';
    },
    tradingNewTitle: function tradingNewTitle() {
      return this.isOctActivity ? TRADING_NEW_OCT_TITLE : TRADING_NEW_TITLE;
    },
    tradingNewContent: function tradingNewContent() {
      return this.isOctActivity ? TRADING_NEW_OCT_CONTENT : TRADING_NEW_CONTENT;
    },
    dialogTitle: function dialogTitle() {
      return {
        tradingNew: this.tradingNewTitle,
        vip: this.options.onlySvip && !this.isEliteVip ? '直播仅限钻石VIP观看哦' : '直播仅限精英/钻石VIP观看哦'
      }[this.pageType] || this.tradingNewTitle;
    },
    textContent: function textContent() {
      return {
        tradingNew: this.tradingNewContent,
        vip: this.options.onlySvip && !this.isEliteVip ? '成为金十数据钻石VIP，即可观看直播，仅需10元/天' : '开通精英/钻石VIP，即可观看，仅需1元/天'
      }[this.pageType] || this.tradingNewContent;
    },
    footerText: function footerText() {
      return this.isOctActivity ? '仅15元开通会员' : '点我升级会员';
    },
    isVipButNotSvip: function isVipButNotSvip() {
      return this.pageType === 'vip' && this.isVip && !this.isEliteVip;
    },
    submitBtnText: function submitBtnText() {
      return this.isLogin ? this.isVipButNotSvip ? '升级VIP' : '成为VIP' : '登录';
    },
    columnName: function columnName() {
      return {
        tradingNew: '同声传译',
        vip: 'vip直播'
      }[this.pageType];
    }
  }),
  data: function data() {
    return {
      visible: this.value
    };
  },

  watch: {
    value: function value(v) {
      this.visible = v;
    },
    visible: function visible(v) {
      this.$emit('input', v);
    }
  },
  created: function created() {},

  methods: {
    close: function close() {
      this.postDialogEvent('我知道了');
      this.visible = false;
    },
    onVipClick: function onVipClick() {
      var jsBridge = this.jsBridge;
      var isApp = jsBridge.isApp;
      if (this.pageType === 'vip') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_utils__["e" /* jin10Behavior */])({
          pageName: 'VIP直播页',
          module: '成为vip弹窗',
          action: '点击',
          type: '按钮',
          object: '成为vip',
          params: {
            title: document.title
          }
        });
      }

      this.postDialogEvent(this.submitBtnText);

      var url = 'https://www.jin10.com/vip/payment/index.html';
      if (this.pageType === 'tradingNew') {
        this.$pushCnzzEvent({ event: '同传直播成为VIP' });
      }

      if (this.isLogin) {
        if (isApp) {
          jsBridge.dispatch('openAppWebViewWithNav', { url: url });
        } else {
          window.open(url, '_blank');
        }
        return false;
      }
      if (isApp) {
        jsBridge.login();
      } else {
        this.$store.dispatch('showLogin');
        this.close();
      }
    },
    onLinkClick: function onLinkClick() {
      this.$pushCnzzEvent({ event: '同传直播升级会员' });
      this.postDialogEvent(this.footerText);
    },
    postDialogEvent: function postDialogEvent(btnText) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_utils__["e" /* jin10Behavior */])({
        pageName: 'tv直播页',
        module: this.columnName + '|\u5347\u7EA7\u63D0\u793A\u5F39\u7A97',
        action: '点击',
        type: '按钮',
        object: btnText,
        params: {
          live_name: document.title,
          btn_text: btnText
        }
      });
    }
  }
});

/***/ }),

/***/ "cwKB":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("LI1s"),
  /* template */
  __webpack_require__("IJUa"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "fMio":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fTYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fZuJ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-play-box tv-video"
  }, [_c('div', {
    staticClass: "jin-play-box__h vip-video--header"
  }, [_c('div', {
    staticClass: "jin-play-box__l"
  }, [_c('h3', {
    staticClass: "jin-play-box__title vip-video--title"
  }, [(_vm.isLive) ? _c('span', {
    staticClass: "vip-video--live-state"
  }, [_vm._v("LIVE")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customTitle || _vm.videoTitle || _vm.title))])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "jin-play-box__r"
  }, [_c('jin-popover', {
    ref: "qrcodePopover",
    attrs: {
      "popper-class": "jin-qrcode-popover",
      "placement": "bottom-end",
      "open-delay": 300,
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "jin-qrcode"
  }, [_c('dl', [_c('dt', [_c('p', [_vm._v("扫描右侧二维码")]), _vm._v(" "), _c('p', [_vm._v("畅享手机看直播")])]), _vm._v(" "), _c('dd', [(_vm.liveType === 'tradingNew') ? _c('img', {
    attrs: {
      "src": require("../../../assets/img/trading_qrcode.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/img/tv_qrcode.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:qrcodePopover",
      arg: "qrcodePopover"
    }],
    staticClass: "jin-play-box__btn jin-play-box__phone"
  }, [_c('icon', {
    attrs: {
      "type": "phone"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tv-video__b"
  }, [(!_vm.repeatImageUrl) ? [(_vm.liveUrl) ? _c('div', [(_vm.isMobile) ? _c('div', {
    staticClass: "tv-video__box"
  }, [_c('video', {
    attrs: {
      "id": "J_tv_video_vip",
      "width": "100%",
      "height": "100%",
      "controls": "controls",
      "webkit-playsinline": "",
      "playsinline": "",
      "x-webkit-airplay": "allow",
      "x5-playsinline": "",
      "autoplay": "autoplay"
    }
  })]) : _c('div', {
    staticClass: "tv-video__box",
    attrs: {
      "id": "J_tv_box_vip"
    }
  })]) : _c('div', {
    staticClass: "tv-video__poster",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toVipPage
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.posterUrl
    }
  })])] : _c('div', {
    staticClass: "tv-video__poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.repeatImageUrl
    }
  }), _vm._v(" "), (_vm.repeatImageUrl && _vm.isVipPageAndNotAVip) ? _c('a', {
    staticClass: "tv-video__vip-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toVipPage
    }
  }) : (_vm.isVip) ? _c('jin-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showRepeat
    }
  }, [_c('icon', {
    attrs: {
      "type": "repeat-video"
    }
  }), _vm._v(" "), _c('span', [_vm._v("点击这里收看最近一期节目")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isShowNextTV && false) ? _c('div', {
    staticClass: "tv-video__mask"
  }, [_c('div', {
    staticClass: "tv-video-tips"
  }, [_c('h4', {
    staticClass: "tv-video-tips__h"
  }, [_vm._v("\n          温馨提示：" + _vm._s(_vm.nowDatas.prevue.title) + "即将直播\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-tips__b"
  }, [_c('jin-button', {
    on: {
      "click": _vm.closeNextTV
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('jin-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showNextTV
    }
  }, [_vm._v("提前进入")])], 1)])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tv-video__f"
  }, [_c('div', {
    staticClass: "tv-video__l"
  }, [_c('div', {
    staticClass: "tv-video-info"
  }, [(_vm.getEmceeInfo('pic')) ? _c('img', {
    staticClass: "tv-video-info__avatar",
    attrs: {
      "src": _vm.getEmceeInfo('pic'),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('nick')) ? _c('span', {
    staticClass: "tv-video-info__text"
  }, [_vm._v("关注" + _vm._s(_vm.getEmceeInfo('nick')))]) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('weibo')) ? _c('a', {
    staticClass: "tv-video-info__btn is-weibo",
    attrs: {
      "target": "_blank",
      "href": _vm.getEmceeInfo('weibo')
    }
  }, [_c('icon', {
    attrs: {
      "type": "weibo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('jin-popover', {
    ref: "wechatPopover",
    attrs: {
      "placement": "right",
      "trigger": "hover"
    }
  }, [_c('img', {
    attrs: {
      "width": "200",
      "src": _vm.wechatUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "popover",
      rawName: "v-popover:wechatPopover",
      arg: "wechatPopover"
    }],
    staticClass: "tv-video-info__btn is-wechat"
  }, [(_vm.wechatUrl) ? _c('icon', {
    attrs: {
      "type": "wechat"
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share"
  }, [_c('share-button', {
    attrs: {
      "dir": "vertical"
    }
  })], 1)]), _vm._v(" "), _c('vip-dialog', {
    model: {
      value: (_vm.showVipDialog),
      callback: function($$v) {
        _vm.showVipDialog = $$v
      },
      expression: "showVipDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "feRo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/renzhenglianmeng.4c9faf7.png";

/***/ }),

/***/ "gBM3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/kexinwangzhan@2x.68a19e0.png";

/***/ }),

/***/ "hSG4":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.liveInfo && (_vm.liveInfo.roomID !== 33 || _vm.hasBuyDing)) ? _c('div', {
    ref: "notice",
    staticClass: "jin-notice"
  }, [_c('div', {
    staticClass: "jin-notice__list"
  }, _vm._l((_vm.notice.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "jin-notice__item"
    }, [_c('div', {
      staticClass: "jin-notice__wrap"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "jin-notice__ad"
  }, [_c('div', {
    staticClass: "jin-notice__wrap"
  }, [_c('h3', [_vm._v(_vm._s(_vm.notice.infoTitle))]), _vm._v(" "), _vm._l((_vm.notice.infoList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "jin-notice__contact"
    }, [(item.qrcode) ? _c('img', {
      style: (item.style),
      attrs: {
        "src": item.qrcode
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.number))])])])
  })], 2)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ "i2ni":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAclBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9eWEHEAAAAJXRSTlMAjeHuvvRwPLvwENmUdjMmCoRRZBHRx7GtaFIrIR0JpYeAeVg1lZ+/vwAAAOtJREFUKM+FkumWgyAMRoNAQa3LjF2ny3T73v8Vy6JGW3p6/+ToPQkhhL6y/j8SHW4207q0VTNzB+BkLEZUTcwCmUBA5jEuWW6jEOZM1BohffJqkP4LoqCeQnhLkYd3F5rwq8fK+1h1MbUA+q6O3U4CHdF9s+ut4MIOcz2FtodzJTC7b5ScWn2UBrAunJOyBUoXtF4nJOXQXiJnKX8c+yDD7xJoRxnYcFkLmF52WWDLDVWAIGZ+lQaQxYviIaj3VB5fDeDPxfTgl4Bmy08WUanHHlipuCbt65oMlQM5L9iUWiVWk2kqW/JSf+cJxNgcknIJ2/MAAAAASUVORK5CYII="

/***/ }),

/***/ "l/+V":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/header_info_qihuo.7a042e2.png";

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUser", function() { return setUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOpation", function() { return getOpation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAppUserDataState", function() { return setAppUserDataState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLiveType", function() { return setLiveType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLiveInfo", function() { return setLiveInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLiveUrl", function() { return setLiveUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLiveState", function() { return setLiveState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setChannelLiveState", function() { return setChannelLiveState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setChatReadyState", function() { return setChatReadyState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkDevice", function() { return checkDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateServerTime", function() { return updateServerTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPosterUrl", function() { return setPosterUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmcee", function() { return setEmcee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVideoID", function() { return setVideoID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTradingVideoID", function() { return setTradingVideoID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPrevueTime", function() { return setPrevueTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFmLivePlayState", function() { return setFmLivePlayState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFmReplayState", function() { return setFmReplayState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFmVideo", function() { return setFmVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFmEmmecNotice", function() { return setFmEmmecNotice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFmSignVisibleState", function() { return setFmSignVisibleState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWeekTalkDatas", function() { return setWeekTalkDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWeekTalkDatas", function() { return getWeekTalkDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWeekTalkID", function() { return getWeekTalkID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showLogin", function() { return showLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPageType", function() { return setPageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVipState", function() { return setVipState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTrySeeRemain", function() { return setTrySeeRemain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getServiceQRCode", function() { return getServiceQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLocalTime", function() { return setLocalTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTopNavs", function() { return setTopNavs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWindowWidth", function() { return setWindowWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDingInfo", function() { return getDingInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDingShowConfig", function() { return getDingShowConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateRoomInfo", function() { return updateRoomInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons__ = __webpack_require__("N4+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_tv_main__ = __webpack_require__("FbZm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commons_constants__ = __webpack_require__("kzx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apis__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__apis_qh_ding__ = __webpack_require__("Ssb8");





var _this = this;












var setChatState = function setChatState(datas) {
  var chatVm = __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$chatVm;
  if (!chatVm) {
    return false;
  }
  chatVm.$store.dispatch('getRegState', chatVm);
  chatVm.$store.dispatch('setLoginState', {
    type: 'login',
    datas: {
      data: datas
    }
  });
  chatVm.$store.dispatch('getCanChangeNickState', chatVm);
  if (typeof CHAT_SOCKET !== 'undefined') {
    CHAT_SOCKET.reconnect();
  }
};

var getUser = function getUser(_ref, params) {
  var state = _ref.state,
      commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_8__commons__["a" /* jin10Login */].getUser({ forceUpdate: true }).then(function (data) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* UPDATE_USER */], data);
      resolve(data);
    }).catch(function (e) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* UPDATE_USER */], { fail: true });
      reject(e);
    });
  });
};

var setUser = function setUser(_ref2, data) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* UPDATE_USER */], data);
};

var getOpation = function getOpation(_ref3) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__commons_utils__["b" /* addScript */])(__WEBPACK_IMPORTED_MODULE_7__commons_config__["b" /* requestUrl */].configs + '?' + Date.now(), function () {
      var datas = window.GENERAL_CHANNEL_CONFIG;
      datas = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, datas, {
        'live-btnws': {
          roomID: 39
        }
      });
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* UPDATE_OPTIONS */], datas);
      resolve(datas);
    });
  });
};

var setAppUserDataState = function setAppUserDataState(_ref4, isFetchAppUserData) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* UPDATE_FETCH_APP_USER_DATA_STATE */], isFetchAppUserData);
};

var setLiveType = function setLiveType(_ref5, type) {
  var commit = _ref5.commit,
      getters = _ref5.getters;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* UPDATE_LIVE_TYPE */], type);
  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* UPDATE_LIVE_INFO */], getters.options[type]);
};

var setLiveInfo = function setLiveInfo(_ref6, payload) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* UPDATE_LIVE_INFO */], payload);
};

var setLiveUrl = function setLiveUrl(_ref7, url) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* UPDATE_LIVE_URL */], url);
};

var setLiveState = function setLiveState(_ref8, isLive) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* UPDATE_LIVE_CURRENT_STATE */], isLive);
};

var setChannelLiveState = function setChannelLiveState(_ref9, payload) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* UPDATE_CHANNEL_LIVE_STATE */], payload);
};

var setChatReadyState = function setChatReadyState(_ref10, isReady) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* UPDATE_CHAT_READY_STATE */], isReady);
};

var checkDevice = function checkDevice(_ref11, isMobile) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* CHECK_DEVICE */], isMobile);
};

var updateServerTime = function updateServerTime(_ref12, time) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* UPDATE_SERVER_TIME */], time);
};

var setPosterUrl = function setPosterUrl(_ref13, url) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* UPDATE_POSTER_URL */], url);
};

var setEmcee = function setEmcee(_ref14, name) {
  var commit = _ref14.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["l" /* UPDATE_EMCEE */], name);
};

var setVideoID = function setVideoID(_ref15, id) {
  var commit = _ref15.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["m" /* UPDATE_VIDEO_ID */], id);
};

var setTradingVideoID = function setTradingVideoID(_ref16, id) {
  var commit = _ref16.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* UPDATE_TRADING_VIDEO_ID */], id);
};

var setPrevueTime = function setPrevueTime(_ref17, time) {
  var commit = _ref17.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* UPDATE_PREVUE_TIME */], time);
};

var setFmLivePlayState = function setFmLivePlayState(_ref18, isPlay) {
  var commit = _ref18.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* UPDATE_FM_LIVE_PLAY_STATE */], isPlay);
};

var setFmReplayState = function setFmReplayState(_ref19, isPlay) {
  var commit = _ref19.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* UPDATE_FM_REPLAY_STATE */], isPlay);
};

var setFmVideo = function setFmVideo(_ref20, payload) {
  var commit = _ref20.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* UPDATE_FM_VIDEO */], payload);
};

var setFmEmmecNotice = function setFmEmmecNotice(_ref21, notice) {
  var commit = _ref21.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* UPDATE_FM_EMMEC_NOTICE */], notice);
};

var setFmSignVisibleState = function setFmSignVisibleState(_ref22, isShow) {
  var commit = _ref22.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* UPDATE_FM_SIGN_VISIBLE */], isShow);
};

var setWeekTalkDatas = function setWeekTalkDatas(_ref23, payload) {
  var commit = _ref23.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* UPDATE_WEEK_TALK_DATAS */], payload);
};

var allWeelky = {};
var getWeekTalkDatas = function getWeekTalkDatas(store, id) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__commons_fetch__["a" /* fetch */])({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_7__commons_config__["c" /* requestTopicUrl */].weekTalk.replace('{id}', id) + '?' + Date.now(),
      success: function success(datas) {
        if (!allWeelky[id]) {
          allWeelky[id] = datas;
        }
        setWeekTalkDatas(store, allWeelky[id]);
        resolve(datas);
      }
    });
  });
};

var getWeekTalkID = function getWeekTalkID(store) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__commons_fetch__["a" /* fetch */])({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_7__commons_config__["c" /* requestTopicUrl */].config + '?' + Date.now(),
      success: function success(datas) {
        var id = datas.latestId;
        setWeekTalkDatas(store, {
          id: id
        });
        resolve(id);
      }
    });
  });
};

var isShowLogin = false;
var showLogin = function showLogin(_ref24, type) {
  var commit = _ref24.commit,
      state = _ref24.state;

  if (isShowLogin) {
    return false;
  }
  isShowLogin = true;
  setTimeout(function () {
    isShowLogin = false;
  }, 1000);
  type = type || 'login';
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__commons__["b" /* showLoginBox */])({
      embedded: type === 'embedded',
      loginCallback: function loginCallback(datas) {
        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* UPDATE_USER */], datas);
        setChatState(datas);
        __WEBPACK_IMPORTED_MODULE_10__views_tv_main__["BUS"].$emit(__WEBPACK_IMPORTED_MODULE_11__commons_constants__["b" /* BusEvent */].REFRESH_LIVE_INFO);
        resolve();
      },
      oauthCallback: function oauthCallback(a) {
        if (document.getElementById('J_comment')) {
          location.reload();
          return false;
        }
        getUser({ commit: commit }).then(function (data) {
          setChatState({ data: data });
          resolve();
        });
      },
      bindCallback: function bindCallback() {
        __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(state.user, 'bindmobile', 1);
      },

      type: type === 'embedded' ? 'login' : type
    });
  });
};

var setPageType = function setPageType(_ref25, type) {
  var commit = _ref25.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* SET_PAGE_TYPE */], type);
};

var setVipState = function setVipState(_ref26, type) {
  var commit = _ref26.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* SET_VIP_STATE */], type);
};

var setTrySeeRemain = function setTrySeeRemain(_ref27, data) {
  var commit = _ref27.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* SET_TRY_FREE_REMAIN */], data);
};

var getServiceQRCode = function () {
  var _ref28 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref29, data) {
    var commit = _ref29.commit;

    var _ref30, _data;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__apis__["a" /* getServiceQRCode */])();

          case 3:
            _ref30 = _context.sent;
            _data = _ref30.data;

            commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* SET_SERVICE_QRCODE */], _data.data.formData.list);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](0);

            console.error(_context.t0);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 8]]);
  }));

  return function getServiceQRCode(_x, _x2) {
    return _ref28.apply(this, arguments);
  };
}();

var setLocalTime = function setLocalTime(_ref31) {
  var commit = _ref31.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["A" /* SET_LOCAL_TIME */]);
};

var setTopNavs = function setTopNavs(_ref32, data) {
  var commit = _ref32.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["B" /* SET_TOP_NAVS */], data);
};

var setWindowWidth = function setWindowWidth(_ref33, data) {
  var commit = _ref33.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["C" /* SET_WINDOW_WIDTH */], data);
};

var getDingInfo = function () {
  var _ref34 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref35) {
    var commit = _ref35.commit;

    var _ref36, data, hasBuyList;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__apis_qh_ding__["a" /* getDingMemberInfo */])();

          case 3:
            _ref36 = _context2.sent;
            data = _ref36.data;

            if (data.status === 200 && data.data) {
              hasBuyList = data.data.filter(function (it) {
                return it.is_expired === false && it.product_gid !== 'qh_all_monitor';
              }).map(function (it) {
                return it.product_gid;
              });

              commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["D" /* SET_HAS_BUY_DING */], hasBuyList.length);
              commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* SET_HAS_GET_DING_INFO */], true);
            }
            _context2.next = 12;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* SET_HAS_GET_DING_INFO */], true);
            console.error(_context2.t0);

          case 12:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[0, 8]]);
  }));

  return function getDingInfo(_x3) {
    return _ref34.apply(this, arguments);
  };
}();

var getDingShowConfig = function () {
  var _ref37 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref38) {
    var commit = _ref38.commit;

    var _ref39, data;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__apis_qh_ding__["b" /* getRemoteDingShowConfig */])();

          case 3:
            _ref39 = _context3.sent;
            data = _ref39.data;

            console.log('%c data', 'color: red', data);
            commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["F" /* SET_DING_SHOW_CONFIG */], data.data.data.formData.ding_live);
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3['catch'](0);

            console.error(_context3.t0);

          case 12:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[0, 9]]);
  }));

  return function getDingShowConfig(_x4) {
    return _ref37.apply(this, arguments);
  };
}();

var updateRoomInfo = function updateRoomInfo(_ref40, data) {
  var commit = _ref40.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["G" /* UPDATE_ROOM_INFO */], data);
};

/***/ }),

/***/ "mrkT":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("RbSC")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("LDL9"),
  /* template */
  __webpack_require__("6lwT"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-464cf670",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "nsZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oZ2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p5f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__video__ = __webpack_require__("JH/5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vipVideo__ = __webpack_require__("NAjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vipVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vipVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__videoForType__ = __webpack_require__("LOYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__videoForType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__videoForType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__list__ = __webpack_require__("ROKJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notice__ = __webpack_require__("STAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TradingNotice__ = __webpack_require__("cwKB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TradingNotice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TradingNotice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons_wechatShareConfig__ = __webpack_require__("Kc2c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RelatedRecommend__ = __webpack_require__("jqDE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RelatedRecommend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_RelatedRecommend__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  components: {
    CVideo: __WEBPACK_IMPORTED_MODULE_2__video___default.a,
    CVipVideo: __WEBPACK_IMPORTED_MODULE_3__vipVideo___default.a,
    CList: __WEBPACK_IMPORTED_MODULE_5__list___default.a,
    CNotice: __WEBPACK_IMPORTED_MODULE_6__notice___default.a,
    CTradingNotice: __WEBPACK_IMPORTED_MODULE_7__TradingNotice___default.a,
    CVideoForType: __WEBPACK_IMPORTED_MODULE_4__videoForType___default.a,
    RelatedRecommend: __WEBPACK_IMPORTED_MODULE_9__components_RelatedRecommend___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['user', 'isLogin', 'options']), {
    isTrading: function isTrading() {
      return this.$route.meta.type === 'tradingNew';
    },
    isType: function isType() {
      return this.options.conflictProgram === this.$route.meta.type;
    },
    isVip: function isVip() {
      return this.$route.meta.type === 'vip';
    }
  }),
  data: function data() {
    return {};
  },
  mounted: function mounted() {

    var title = '';
    var desc = '';
    if (this.options && this.$route.meta.type && this.options[this.$route.meta.type]) {
      title = this.options[this.$route.meta.type].title || document.title;
      desc = this.options[this.$route.meta.type].desc;
      document.title = title;

      document.body.classList.add('is-' + this.$route.meta.type);
      document.body.setAttribute('data-title', title);
      document.body.setAttribute('data-desc', desc);
      if (window._modifyAppShareUrl) {
        window._modifyAppShareUrl({
          title: title,
          subTitle: desc,
          url: window.location.href,
          icon: 'https://cdn.jin10.com/assets/img/commons/app-logo.png'
        });
      }
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__commons_wechatShareConfig__["a" /* default */])({
      title: document.title,
      desc: desc,
      imgUrl: 'https://cdn.jin10.com/assets/img/commons/app-logo.png'
    });
  },

  methods: {
    updateTradingNotice: function updateTradingNotice() {}
  }
});

/***/ }),

/***/ "p7IU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAZdJREFUWEftmDtLA0EQx2c8CFdYWBjBPK61sQhKwFaIYKNegmdt6yfI+QC3ktwHsLHRTiGah1a2NqksxG+QM7HwATYimtsRxUuEM4FkPVh0r92ZnT+/2ZvZWQTJP5RcHyiBohlSBEMhaK3fRj3kSS0VuyquoCcaRMQ/kOKsfWMR0SEBaYhYG9O1zB6LPftBTLs5DeAtiATt5otEd2XH2P2+HhBo2u41EU36Roi4XCkkTzoCXUZE26EIBHiqOMZIT4FLebcGQDNtIw3mqzvGuTQCc3Y97REeI9A4IO6n9MQaY8h9gdamG3/jlA6D4BCHx5JjXPQk6C+uMtIPGL6EIaSfPVUd7IfWT7aK4P8kaDGKaHA/esSiTVECov6BM5izGxkOvExEw4BwGtGTVpHha7sObjUmWi2aFQ3cxf+hXEgUe7e6fP2SAKY6Rtpi1YmfSdNJTNkFZjcac8R5SdoUf6RS6p8kpMM/8LaqkwyM7stREQyNoLQXVumv/NIPTdKPndIP7p+tTuanD9Gy8Nv+qlCLElUE/zzBd8dH6SnR9nalAAAAAElFTkSuQmCC"

/***/ }),

/***/ "qFKE":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("oZ2+")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("YjHF"),
  /* template */
  __webpack_require__("ti6K"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "qNZ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/certification.1c5d039.png";

/***/ }),

/***/ "qd8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var jsUrl = 'https://cdn.jin10.com/assets/js/plugins/dsbridge.js';

function loadJs(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (typeof callback !== 'undefined') {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
  }
  script.src = url;
  document.body.appendChild(script);
}

function myloadjs(url, callback) {
  loadJs(url, callback);
}

var _log = function _log(txt) {
  if (window.location.href.indexOf('local') > -1) {
    var $item = document.createElement('div');
    $item.innerHTML = txt;
  }
};
var openUrl = function openUrl(url) {
  _log('openUrl');

  if (window.dsBridge.hasNativeMethod('comm.isAndroid') && window.dsBridge.hasNativeMethod('comm.openUrl')) {
    window.dsBridge.call('comm.openUrl', url);
  } else if (window.dsBridge.hasNativeMethod('comm.isAndroid') && window.dsBridge.hasNativeMethod('comm.openAppWebViewWithNav')) {
    window.dsBridge.call('comm.openAppWebViewWithNav', url);
  }
  if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined' && window.webkit.messageHandlers.openUrl) {
    _log('ios url');
    window.webkit.messageHandlers.openUrl.postMessage(url);
  } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined' && typeof window.webkit.messageHandlers.openAppWebView !== 'undefined') {
    _log('ios openAppWebView');
    window.webkit.messageHandlers.openAppWebView.postMessage(url);
  } else {
    window.open(url);
  }
};

var loadBsBridgeResource = function loadBsBridgeResource(cb) {
  if (typeof window.dsBridge === 'undefined') {
    myloadjs(jsUrl, function () {
      cb();
    });
  } else {
    cb();
  }
};
window._modifyAppShareUrl = function (options) {
  var name = 'modifyAppShareUrl';
  loadBsBridgeResource(function () {
    if (window.dsBridge.hasNativeMethod('comm.isAndroid')) {
      window.dsBridge.call('comm.' + name, options);
      _log('android ' + name);
    } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined' && window.webkit.messageHandlers[name]) {
      window.webkit.messageHandlers[name].postMessage(options);
      _log('ios ' + name);
    }
  });
};
window._uploadAppStatics = function (typedesc, referer, oTtype, exOptions) {
  var cb = function cb() {
    if (!exOptions) {
      exOptions = {};
    }

    var ops = {
      click: '点击',
      view: '浏览',
      search: '搜索',
      change: '切换'
    };
    var enableUrl = exOptions.enableUrl;

    var options = {
      type: '' + ops[oTtype || 'click'] + typedesc,
      referer: '' + referer,
      source_type: 'tv'
    };
    if (enableUrl !== false) {
      options.url = exOptions.url || window.location.href;
    }

    window.console.log('用户行为:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options));

    if (window.dsBridge.hasNativeMethod('comm.isAndroid')) {
      window.dsBridge.call('comm.uploadAppStatics', options);
      _log('androidos uploadAppStatics');
    } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined' && window.webkit.messageHandlers.uploadAppStatics) {
      window.webkit.messageHandlers.uploadAppStatics.postMessage(options);
      _log('ios uploadAppStatics');
    }
  };

  if (typeof window.dsBridge === 'undefined') {
    myloadjs(jsUrl, function () {
      cb();
    });
  } else {
    cb();
  }
};

var __init__ = function __init__() {
  var cb = function cb() {
    var $list = document.body.querySelectorAll('.is-vip .chat-topad');
    for (var i = 0; i < $list.length; i++) {
      var $item = $list[i];

      if ($item.getAttribute('is-init') !== '1') {
        (function () {
          $item.setAttribute('is-init', '1');
          var $close = $item.querySelector('.chat-topad_close');
          var $link = $item.querySelector('a');
          $close.addEventListener('click', function () {
            window._uploadAppStatics('广告图关闭', 'VIP直播');
          });
          $link.addEventListener('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            loadBsBridgeResource(function () {
              openUrl($link.getAttribute('href'));
              window._uploadAppStatics('直播广告', 'VIP直播');
            });
          });
        })();
      }
    }
    var $topList = document.body.querySelectorAll('.is-vip .chat-top-news .chat-list_item');
    for (var _i = 0; _i < $topList.length; _i++) {
      var $topItem = $topList[_i];

      if ($topItem.getAttribute('is-init') !== '1') {
        $topItem.setAttribute('is-init', '1');
        var $close = $topItem.querySelector('.chat-tv_close');
        var $link = $topItem.querySelector('.chat-message_text');
        if ($close) {
          $close.addEventListener('click', function () {
            window._uploadAppStatics('直播置顶评论关闭', 'VIP直播');
          });
        }

        if ($link) {
          $link.addEventListener('click', function () {
            window._uploadAppStatics('直播置顶评论', 'VIP直播');
          });
        }
      }
    }
  };
  setInterval(function () {
    cb();
  }, 1000);
  cb();
};
__init__();

/***/ }),

/***/ "rRu1":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("xrNy")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("cF0O"),
  /* template */
  __webpack_require__("7EpH"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ranQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/tips@2x.a102335.png";

/***/ }),

/***/ "ti6K":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-container",
    class: [_vm.$route.meta.type ? ("jin-" + (_vm.$route.meta.type)) : '', {
      'is-vip-page': _vm.vipLivePage
    }]
  }, [_c('div', {
    staticClass: "jin-box"
  }, [_c('header-new', {
    attrs: {
      "user": _vm.headerUser,
      "show-search": false,
      "show-follow-us": false,
      "mobileShowTabBar": false
    },
    on: {
      "login": function($event) {
        return _vm.onUserAction('login')
      },
      "logout": function($event) {
        return _vm.onUserAction('logout')
      },
      "register": function($event) {
        return _vm.onUserAction('register')
      }
    }
  }, [_c('template', {
    slot: "navCustom"
  }, [_c('RoomNav', {
    on: {
      "show-live-tips": _vm.onRoomNavLiveTips
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "drawerContent"
  }, [_c('RoomNav', {
    on: {
      "show-live-tips": _vm.onRoomNavLiveTips
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "jin-page"
  }, [(_vm.showContent) ? _c('div', {
    staticClass: "tv-wrap tv-wrap-main"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('footer-new'), _vm._v(" "), (_vm.passwordPopup) ? _c('div', {
    staticClass: "jin-password-popup"
  }, [_c('div', {
    staticClass: "jin-password-popup-content"
  }, [_c('div', {
    staticClass: "jin-password-popup-title"
  }, [_vm._v("请输入密码")]), _vm._v(" "), _c('div', {
    staticClass: "jin-password-popup-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jin-password-popup-button"
  }, [_c('button', {
    staticClass: "jin-password-popup-button-cancel",
    on: {
      "click": _vm.closePasswordPopup
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "jin-password-popup-button-confirm",
    on: {
      "click": _vm.checkPassword
    }
  }, [_vm._v("确定")])])])]) : _vm._e(), _vm._v(" "), _c('BaseOverlay', {
    attrs: {
      "z-index": 2000
    },
    model: {
      value: (_vm.isOverlayVisible),
      callback: function($$v) {
        _vm.isOverlayVisible = $$v
      },
      expression: "isOverlayVisible"
    }
  }, [_c('div', {
    staticClass: "live-tips-content"
  }, [_c('img', {
    staticClass: "live-tips-content-img",
    attrs: {
      "src": __webpack_require__("ranQ"),
      "alt": "live-tips"
    }
  }), _vm._v(" "), _c('p', [_vm._v("当前节目正在直播，是否继续跳转")]), _vm._v(" "), _c('div', {
    staticClass: "live-tips-content-footer"
  }, [_c('glass-btn', {
    attrs: {
      "type": "default",
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.isOverlayVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('glass-btn', {
    attrs: {
      "type": "primary",
      "round": "",
      "size": "large"
    },
    on: {
      "click": _vm.handleJump
    }
  }, [_vm._v("跳转")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "tn2w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uToA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_constants__ = __webpack_require__("kzx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__("Du/2");




var _types$UPDATE_USER$ty;




/* harmony default export */ __webpack_exports__["a"] = (_types$UPDATE_USER$ty = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* UPDATE_USER */], function (state, datas) {
  state.user = datas;

  if (!datas || datas.fail) {
    state.hasGetUser = true;
    return false;
  }

  try {
    if (datas.extraInfo) {
      console.log('datas.extraInfo', datas.extraInfo);
      var vipInfo = datas.vip_info;
      var _datas$extraInfo = datas.extraInfo,
          isExpired = _datas$extraInfo.isExpired,
          type = _datas$extraInfo.type,
          payType = _datas$extraInfo.payType;

      if (type !== 'common') {
        if (!isExpired) {
          state.isVip = true;

          if (vipInfo && vipInfo.ucenter_vip && vipInfo.ucenter_vip.vip_type === '年') {
            state.isYearVip = true;
          }

          if (type === 'vip' && payType === '黑金') {
            state.isBlackGoldVip = true;
          }

          if (vipInfo && vipInfo.ucenter_super && vipInfo.ucenter_super.is_vip) {
            state.isSuperVip = true;
          }
        }
      }
      if (type === 'elite' && !isExpired) {
        state.isEliteVip = true;
      }
    } else {
      var getTime = function getTime(str) {
        return new Date(str.replace(/-/g, '/')).getTime();
      };

      if (datas.vip_info) {
        var _datas$vip_info = datas.vip_info,
            ucenter_elite = _datas$vip_info.ucenter_elite,
            ucenter_vip = _datas$vip_info.ucenter_vip;

        if (ucenter_elite && getTime(ucenter_elite.expiration) > Date.now() || ucenter_vip && getTime(ucenter_vip.expiration) > Date.now()) {
          state.isVip = true;
        }
      }
    }
    state.hasGetUser = true;
  } catch (error) {
    state.hasGetUser = true;
    console.log('login error', error);
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* UPDATE_OPTIONS */], function (state, datas) {
  if (datas) {
    for (var name in datas) {
      __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state.options, name, datas[name]);
    }
    state.hasGetOptions = true;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* UPDATE_LIVE_TYPE */], function (state, type) {
  state.liveType = type;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* UPDATE_LIVE_INFO */], function (state, payload) {
  state.liveInfo = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* UPDATE_FETCH_APP_USER_DATA_STATE */], function (state, isFetchAppUserData) {
  state.isFetchAppUserData = isFetchAppUserData;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* UPDATE_LIVE_URL */], function (state, url) {
  state.liveUrl = url;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* UPDATE_LIVE_CURRENT_STATE */], function (state, isLive) {
  state.isLive = isLive;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* UPDATE_CHAT_READY_STATE */], function (state, isReady) {
  state.chatReadyState = isReady;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* CHECK_DEVICE */], function (state, isMobile) {
  state.isMobile = isMobile;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* UPDATE_SERVER_TIME */], function (state, time) {
  state.serverTime = time * 1000;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* UPDATE_POSTER_URL */], function (state, url) {
  state.posterUrl = url;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* UPDATE_EMCEE */], function (state, name) {
  state.emcee = name;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* UPDATE_VIDEO_ID */], function (state, id) {
  state.videoID = id;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* UPDATE_TRADING_VIDEO_ID */], function (state, id) {
  state.tradingVideoID = id;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* UPDATE_PREVUE_TIME */], function (state, time) {
  state.prevueTime = time;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["p" /* UPDATE_CHANNEL_LIVE_STATE */], function (state, payload) {
  var channelLiveState = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.channelLiveState);
  for (var key in payload) {
    channelLiveState[key] = payload[key];
  }

  state.channelLiveState = channelLiveState;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["q" /* UPDATE_FM_LIVE_PLAY_STATE */], function (state, isPlay) {
  state.fmLivePlayState = isPlay;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["r" /* UPDATE_FM_REPLAY_STATE */], function (state, isPlay) {
  state.fmReplayState = isPlay;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["s" /* UPDATE_FM_VIDEO */], function (state, payload) {
  for (var key in payload) {
    state.fmVideo[key] = payload[key];
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["t" /* UPDATE_FM_EMMEC_NOTICE */], function (state, notice) {
  state.fmEmmecNotice = notice;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["u" /* UPDATE_FM_SIGN_VISIBLE */], function (state, isShow) {
  state.isShowFMSign = isShow;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["v" /* UPDATE_WEEK_TALK_DATAS */], function (state, payload) {
  for (var key in payload) {
    __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(state.weekTalkDatas, key, payload[key]);
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* SET_PAGE_TYPE */], function (state, type) {
  state.pageType = type;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["x" /* SET_VIP_STATE */], function (state, vip) {
  state.isVip = vip;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["y" /* SET_TRY_FREE_REMAIN */], function (state, data) {
  var id = data.id,
      time = data.time,
      uid = data.uid;

  if (state.trySeeRemain[uid]) {
    state.trySeeRemain[uid][id] = time;
  } else {
    state.trySeeRemain = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.trySeeRemain, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, uid, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, id, time)));
  }
  localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__commons_constants__["a" /* StorageKey */].TRY_SEE_CACHE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.trySeeRemain));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["z" /* SET_SERVICE_QRCODE */], function (state, data) {
  state.serviceQRCodeConfig = data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["A" /* SET_LOCAL_TIME */], function (state) {
  state.localTime = Date.now();
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["B" /* SET_TOP_NAVS */], function (state, data) {
  state.topNavs = data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["C" /* SET_WINDOW_WIDTH */], function (state, width) {
  state.windowWidth = width;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["D" /* SET_HAS_BUY_DING */], function (state, hasBuyDing) {
  state.hasBuyDing = hasBuyDing;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["E" /* SET_HAS_GET_DING_INFO */], function (state, bool) {
  state.hasGetDingInfo = bool;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["F" /* SET_DING_SHOW_CONFIG */], function (state, data) {
  state.dingShowConfig = data;
  state.hasGetDingShowConfig = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$ty, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* UPDATE_ROOM_INFO */], function (state, data) {
  state.chatRooms = data || {};
}), _types$UPDATE_USER$ty);

/***/ }),

/***/ "wTUH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-config/img/renzhenglianmeng@2x.828f805.png";

/***/ }),

/***/ "xe0A":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip-header",
    class: {
      'is-app': _vm.jsBridge.isApp
    }
  }, [_c('div', {
    staticClass: "vip-header__ctn vip-mobile-header"
  }, [(_vm.jsBridge.isApp) ? _c('button', {
    staticClass: "nav",
    on: {
      "click": _vm.onBack
    }
  }, [_c('i', {
    staticClass: "jin-icon jin-icon_nav-back"
  })]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.headerTitle))]), _vm._v(" "), (_vm.jsBridge.isApp) ? _c('button', {
    staticClass: "share",
    on: {
      "click": _vm.onShare
    }
  }, [_c('i', {
    staticClass: "jin-icon jin-icon_share"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vip-pc-header "
  }, [_c('div', {
    staticClass: "vip-header__ctn"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.headerTitle))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.jin10.com"
    }
  }, [_c('img', {
    staticClass: "vip-pc-header-logo",
    attrs: {
      "src": "//tv.jin10.com/assets/img/vip/logo.png",
      "srcset": "//tv.jin10.com/assets/img/vip/logo@2x.png 2x"
    }
  })])
}]}

/***/ }),

/***/ "xrNy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yOKL":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("p5f7"),
  /* template */
  __webpack_require__("KVJS"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "zN7k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__("Apws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['pageType', 'topNavs']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['liveInfo']), {
  data: function data() {
    return {
      hasReported: false,
      currentMinute: 0,
      onlineTimer: null,
      postLiveName: ''
    };
  },

  watch: {
    currentMinute: function currentMinute(minute) {
      if (minute <= 5) {
        this.postStatics(minute);
      } else if (minute % 5 === 0) {
        this.postStatics(minute);
      }
    },
    $route: function $route(to, from) {
      this.stopLiveVideoTimer();
    }
  },
  methods: {
    report: function report() {
      var _liveInfo$roomID = this.liveInfo.roomID,
          roomID = _liveInfo$roomID === undefined ? -999 : _liveInfo$roomID;

      var live = this.topNavs.find(function (it) {
        return parseInt(it.room_id) === parseInt(roomID);
      });
      if (live && live.name) {
        this.postLiveName = live.name;
      }
      if (this.postLiveName) {
        this.startLiveVideoTimer();
      } else {
        this.stopLiveVideoTimer();
      }
      if (this.hasReported) {
        return false;
      }

      this.hasReported = true;

      var channel = 'WEB_PC';

      if (this.jsBridge.isApp) {
        channel = 'APP_H5' + (this.jsBridge.isIOSApp ? '_IOS' : '_ANDROID');
      } else if (this.isMobile) {
        channel = 'WEB_H5';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__apis__["c" /* report */])({
        live_id: this.videoID,
        channel: channel
      });
    },
    startLiveVideoTimer: function startLiveVideoTimer() {
      var _this = this;

      this.onlineTimer = setInterval(function () {
        _this.currentMinute = _this.currentMinute + 1;
      }, 60000);
    },
    stopLiveVideoTimer: function stopLiveVideoTimer() {
      if (this.onlineTimer) {
        clearInterval(this.onlineTimer);
        this.onlineTimer = null;
      }
      this.currentMinute = 0;
    },
    postStatics: function postStatics(minute) {
      console.log('postStatics', minute);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["e" /* jin10Behavior */])({
        pageName: 'tv直播页',
        module: '直播',
        action: '点击',
        type: '停留时长',
        params: {
          program: this.postLiveName,
          status: this.isPlayingRepeat ? '回放' : '直播中',
          online_time: minute
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopLiveVideoTimer();
  }
}));

/***/ })

},[8]);


// WEBPACK FOOTER //
// custom-config/js/tv.63372aa.js